//Author June Leow
//Date Mar 21th, 2024
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, putAPICallGenerator, callBackGenerator, getSession, showMessage, hideMessage} from '../../../util/util';
import React, {useReducer, useEffect} from 'react';
import _ from 'lodash';
import {Alert, Button, Nav, NavItem, Row, Col, Modal, ModalHeader, ModalBody} from 'reactstrap';
import StepCertification from './sub-components/step-certification';
import StepReportPropertyInfo from './sub-components/step-report-property-info';
import StepSite from './sub-components/step-site';
import StepReview from './sub-components/step-review';
import StepUtilyAncillary from './sub-components/step-utility-ancillary';
import MyFormStep from '../../util/my-form-step';
import {NavLink, useParams} from 'react-router-dom';
import ReactDOM from 'react-dom';
import './upd.css';


const waterFrontList = [
  'OCEAN_FRONT_BEACH','OCEAN_FRONT_NO_BEACH','INLAND_SALTWATER_FRONT_BEACH','INLAND_SALTWATER_FRONT_NO_BEACH','LAKE_FRONT_BEACH','LAKE_FRONT_NO_BEACH','SEASONAL_LAKE_FRONT','RIVER_CANAL_FRONT'
]
let session = getSession();
    let steps = ['General Report & Property Info','Site', 'Property Utilities & Ancillary', 'Data Collector Certification', 'Review'];
    let currentStep = 0;
    let maxStep = 1;

//initialize the state
const initialState = {
  loading:true,
  loadError:false,
  showSubmittedPrompt:false,
  name: session.userFirstName+' '+session.userLastName,
  appraisalFk:-1,
  activeTab:'1',
  steps:steps,
  maxStep:maxStep,
  currentStep:currentStep,
  reviewMessages:[],

  upd:{
    signature:{},
    collectionType:'',
    caseFileID:'',
    lpaID:'',
    pdaHyperlink:'',
    propertyDataCollectorName:'',
    pdaCollectionEntity:'',
    propertyDataCollectorType:'',
    propertyDataCollectorTypeDescription:'',
    dataCollectorAcknowledgement:false,
    dataCollectionDate:'',
    dateOfSignatureReport:'',
    propertyDataCollectorContacts:{
      contactMethod:'',
      contactDetail:'',
      contactMethod2:'',
      contactDetail2:'',
    },
    property:{
      street:'',
      propertyType:'',
      propertyOccupied:'',
      address:{
        streetAddress:'',
        city:'',
        county:'',
        state:'',
        postalCode:'',
        unitNumber:''
      },
      site:{
        lot:{
          lotSize:'',
          lotSizeUnits:'SQUARE_FEET'
        },
        siteFeature:{
          location:{
            locations:[]
          },
          siteView:{
            views:[]
          },
          adverseSiteConditions:[],
          propertyImprovements:[],
          nonResidentialUses:[],
          waterfrontSiteImprovements:[]
        },
        offSiteFeature:{
          road:{
            roadOwnershipType: "PUBLIC",
            yearRoundAccessIndicator: true
          }
        },
        siteUtility:{
          electricalServices:[],
          sewerServices:[],
          waterServices:[],
          gasServices:[]
        }
      },
      buildings:[
        {
          condoCarStorages:[],
          exteriorDeficiencies:[],
          exteriorUpdates:[],
          units:[],
          imageDwellingFront:[], 
          imageDwellingRear:[], 
          imageDwellingLeft:[], 
          imageDwellingRight:[], 
          imageStructureFront:[], 
          imageStructureRear:[], 
          imageStructureLeft:[], 
          imageStructureRight:[], 
          imageBuildingFront:[], 
          imageBuildingRear:[], 
          imageBuildingLeft:[], 
          imageBuildingRight:[], 
          exteriorDeficiency:[],
          exteriorUpdate:[]
        }
      ],
      ancillary:{
        alley:{},
        gas:{},
        appliances:{},
        exterior:{},
        interior:{}
      },
    },
    photos:[],
    imageStreetNumber:[],
    imageUnitNumber:[],
    imageStreetLeft:[],
    imageStreetRight:[],
    imageRoad:[],
  },
  action:'initializing'
};

//reducer function that perform state update
const reducer = getReducer();


const UDPPropertyDataReport  = (props)=>{
  const controller = new AbortController();

  let { updFk} = useParams();
  let newInitialState = Object.assign({}, initialState, {updFk:updFk});
  const [state, dispatch] = useReducer(reducer,newInitialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpGet = getAPICallGenerator(props, {signal:controller.signal});
  const httpPost = postAPICallGenerator(props, {signal:controller.signal});
  const httpPut = putAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    getUPD();
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(()=>{
    if(state.action==='loaded')
      getPhotos();
    else if(state.action==='uploadPhoto')
      uploadPhotos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[state.action])

  useEffect(()=>{ 
    if(state.action!=='initializing')
      saveForm();
  },[state.currentStep])

  //non API call but simpyl manage state
  const toggleShowPrompt = ()=>{
    setState({showSubmittedPrompt:!state.showSubmittedPrompt});
  }

  const update = (newUPD)=>{
    setState({upd:newUPD});
  }

  const save = ()=>{
    saveForm('Save successfully.');
  }

  
  const parseFeetInches = (input) => {
    if (!input) return null;
  
    const trimmed = String(input).trim(); // safely coerce to string
  
    // Decimal feet like "1200" or "1200.5"
    if (/^\d+(\.\d+)?$/.test(trimmed)) {
      const feet = parseFloat(trimmed);
      return { inches: feet * 12, isRawDecimal: true };
    }
  
    // Feet and inches formats like 10'4", 4'5, etc.
    const regex = /^\s*(?:(\d+)\s*')?\s*(\d+)?\s*(?:"?)\s*$/;
    const match = trimmed.match(regex);
    if (!match) return null;
  
    const feet = parseInt(match[1] || '0', 10);
    const inches = parseInt(match[2] || '0', 10);
  
    return { inches: feet * 12 + inches, isRawDecimal: false };
  };
  
  const calculateSquareFeet = (lengthStr, widthStr) => {
    const length = parseFeetInches(lengthStr);
    const width = parseFeetInches(widthStr);
  
    if (!length || !width) return null;
  
    const sqft = (length.inches / 12) * (width.inches / 12);
    return parseFloat(sqft.toFixed(2));
  };

  const areDimensionsEqual = (a, b) => {
    const parsedA = parseFeetInches(a);
    const parsedB = parseFeetInches(b);
  
    if (!parsedA || !parsedB) return false;
  
    return Math.abs(parsedA.inches - parsedB.inches) < 0.01; // small float tolerance
  };

  const normalizeFeetInches = (input) => {
    if (!input) return null;
  
    const trimmed = String(input).trim();
  
    // Case: Decimal feet input like "10.5" or "1200"
    if (/^\d+(\.\d+)?$/.test(trimmed)) {
      const feetFloat = parseFloat(trimmed);
      const totalInches = Math.round(feetFloat * 12);
      const feet = Math.floor(totalInches / 12);
      const inches = totalInches % 12;
      return inches === 0 ? `${feet}'` : `${feet}'${inches}"`;
    }
  
    // Case: inches-only input like 1200"
    const inchesOnlyMatch = trimmed.match(/^(\d+)\s*"?$/);
    if (inchesOnlyMatch) {
      const totalInches = parseInt(inchesOnlyMatch[1], 10);
      const feet = Math.floor(totalInches / 12);
      const inches = totalInches % 12;
      return inches === 0 ? `${feet}'` : `${feet}'${inches}"`;
    }
  
    // Case: feet and optional inches input like 10'0", 10'4, 4'5"
    const regex = /^\s*(?:(\d+)\s*')?\s*(\d+)?\s*(?:"?)\s*$/;
    const match = trimmed.match(regex);
    if (match) {
      const feet = parseInt(match[1] || '0', 10);
      const inches = parseInt(match[2] || '0', 10);
      return inches === 0 ? `${feet}'` : `${feet}'${inches}"`;
    }
  
    return null; // invalid format
  };

  const handleNext = (e) => {
    e.preventDefault();
    const from = state.currentStep;
    const to = from + 1;

    if(from === 1 && to === 2){
      const photoErrors = finalCheckPhoto();
      if(photoErrors.length > 0){
        photoErrors.forEach(message => showMessage('warning', message));
        return;
      }
    }
    updateStep(to);
  }
    


  const finalCheckPhoto = ()=>{
    let messages = [];
    let imageStreetNumber = state.upd.imageStreetNumber?state.upd.imageStreetNumber.slice():[];
    if(imageStreetNumber.length<=0)
        messages.push('Please upload at least a photo of street address number.');
    let imageStreetLeft = state.upd.imageStreetLeft?state.upd.imageStreetLeft.slice():[];
    if(imageStreetLeft.length<=0)
      messages.push('Please upload at least a photo of subject\'s road/street to the left.');
    let imageStreetRight = state.upd.imageStreetRight?state.upd.imageStreetRight.slice():[];
    if(imageStreetRight.length<=0)
      messages.push('Please upload at least a photo of subject\'s road/street to the right.');
    let imageRoad = state.upd.imageRoad?state.upd.imageRoad.slice():[];
    console.log(state.upd.property.site.offSiteFeature.road.roadOwnershipType)
    if(state.upd.property.site.offSiteFeature.road.roadOwnershipType!=='PUBLIC' && state.upd.property.site.offSiteFeature.road.roadOwnershipType!=='' && state.upd.property.site.offSiteFeature.road.roadMaintainedIndicator==='False' && imageRoad.length<=0)
      messages.push('Please upload at least one photo of the road.');
    let adverseSiteConditions = state.upd.property.site.siteFeature.adverseSiteConditions.slice();
    for(let i=0;i<adverseSiteConditions.length;i++){
      if(adverseSiteConditions[i].adverseType.includes('NONE'))
        continue;
      let imageCondition = adverseSiteConditions[i].imageCondition?adverseSiteConditions[i].imageCondition.slice():[];
      if(imageCondition.length<=0)
        messages.push('Please upload at least one photo for each adverse site condition.');
    }

    let views = state.upd.property.site.siteFeature.siteView.views?state.upd.property.site.siteFeature.siteView.views.slice():[];

    for(let i=0;i<views.length;i++){
      if(views[i].viewDescriptionType.includes('NONE'))
        continue;
        let imageView = views[i].imageView?views[i].imageView.slice():[];
        if(imageView.length<=0)
          messages.push('Please upload at least one photo for each site view.');
    }

    //LOCATIONS
    let locations = state.upd.property.site.siteFeature.location.locations.slice();
    for(let i=0;i<locations.length;i++){
      if(locations[i].locationDescriptionType.includes('NONE'))
        continue;
        let imageBorder = locations[i].imageBorder?locations[i].imageBorder.slice():[];
        if(locations[i].locationDescriptionType.includes('BORDERING') && imageBorder.length<=0)
          messages.push('Please upload at least one photo of bordering for each location.');
        let imageWaterfront = locations[i].imageWaterFront?locations[i].imageWaterFront.slice():[];
        if((locations[i].locationDescriptionType==='RIVER_CANAL_FRONT'||locations[i].locationDescriptionType==='LAKE_FRONT_NO_BEACH'||locations[i].locationDescriptionType==='LAKE_FRONT_BEACH'||locations[i].locationDescriptionType==='INLAND_SALTWATER_FRONT_NO_BEACH'||locations[i].locationDescriptionType==='INLAND_SALTWATER_FRONT_BEACH'||locations[i].locationDescriptionType==='OCEAN_FRONT_NO_BEACH'||locations[i].locationDescriptionType==='OCEAN_FRONT_BEACH') && imageWaterfront.length<=0)
          messages.push('Please upload at least one photo for the waterfront.');
    }

    let waterfrontSiteImprovements = state.upd.property.site.siteFeature.waterfrontSiteImprovements.slice();
    for(let i=0;i<waterfrontSiteImprovements.length;i++){
      if(waterfrontSiteImprovements[i].waterfrontImprovementType.includes('NONE'))
        continue;
        let imageWaterfrontImprovement = waterfrontSiteImprovements[i].imageWaterfrontImprovement?waterfrontSiteImprovements[i].imageWaterfrontImprovement.slice():[];
        if(imageWaterfrontImprovement.length<=0)
          messages.push('Please upload at least one photo for each waterfront improvement.');
    }

    let propertyImprovements = state.upd.property.site.siteFeature.propertyImprovements.slice();
    for(let i=0;i<propertyImprovements.length;i++){
      if(propertyImprovements[i].propertyImprovementType.includes('NONE'))
        continue;
        let imagePropertyImprovement = propertyImprovements[i].imagePropertyImprovement?propertyImprovements[i].imagePropertyImprovement.slice():[];
        if(imagePropertyImprovement.length<=0)
          messages.push('Please upload at least one photo for each property improvement.');
        let imagePoolConcern = propertyImprovements[i].ingroundPoolConcerns?propertyImprovements[i].ingroundPoolConcerns.slice():[];
        if(propertyImprovements[i].propertyImprovementType==='INGROUND_POOL' && imagePoolConcern.length<=0)
          messages.push('Please upload at least one photo for each pool inground pool concern.');
    }

    let nonResidentialUses = state.upd.property.site.siteFeature.nonResidentialUses.slice();
    for(let i=0;i<nonResidentialUses.length;i++){
      if(nonResidentialUses[i].nonResidentialUseType.includes('NONE'))
        continue;
        let imageNonResidentialUse = nonResidentialUses[i].imageNonResidentialUse?nonResidentialUses[i].imageNonResidentialUse.slice():[];
        if(imageNonResidentialUse.length<=0)
          messages.push('Please upload at least one photo for each non residential use.');
    }

    let buildings = state.upd.property.buildings.slice();
    for(let i=0;i<buildings.length;i++){
        let imageDwellingFront = !buildings[i].imageDwellingFront?[]:buildings[i].imageDwellingFront.slice();
        let imageDwellingLeft = !buildings[i].imageDwellingLeft?[]:buildings[i].imageDwellingLeft.slice();
        let imageDwellingRight = !buildings[i].imageDwellingRight?[]:buildings[i].imageDwellingRight.slice();
        let imageDwellingRear = !buildings[i].imageDwellingRear?[]:buildings[i].imageDwellingRear.slice();
        if((buildings[i].structureType==='DWELLING' || buildings[i].buildingDesign==='GARDEN' || buildings[i].buildingDesign==='LOW_RISE' || buildings[i].buildingDesign==='MID_RISE' || buildings[i].buildingDesign==='HIGH_RISE' || buildings[i].buildingDesign==='ROWHOUSE_TOWNHOUSE' || buildings[i].buildingDesign==='OTHER')){
          if(imageDwellingFront.length<=0)
            messages.push('Please upload at least one photo of dwelling front.');
          if((buildings[i].attachmentType==='DETACHED' || buildings[i].attachmentType==='LEFT_SEMI_DETACHED') && imageDwellingLeft.length<=0)
            messages.push('Please upload at least one photo of dwelling left.');
          if((buildings[i].attachmentType==='DETACHED' || buildings[i].attachmentType==='RIGHT_SEMI_DETACHED') && imageDwellingRight.length<=0)
            messages.push('Please upload at least one photo of dwelling right.');
          if(imageDwellingRear.length<=0)
            messages.push('Please upload at least one photo of dwelling rear.');
        }

        let imageStructureFront = !buildings[i].imageStructureFront?[]:buildings[i].imageStructureFront.slice();
        let imageStructureRear = !buildings[i].imageStructureRear?[]:buildings[i].imageStructureRear.slice();
        if(state.upd.property.propertyType=='SF' && imageStructureFront.length<=0)
          messages.push('Please upload at least one photo for the structure front.');
        if(state.upd.property.propertyType=='SF' && imageStructureRear.length<=0)
          messages.push('Please upload at least one photo for the structure rear.');
        let imageStructureLeft = !buildings[i].imageStructureLeft?[]:buildings[i].imageStructureLeft.slice();
        let imageStructureRight = !buildings[i].imageStructureRight?[]:buildings[i].imageStructureRight.slice();
        if(state.upd.property.propertyType=='SF' && (buildings[i].attachmentType==='DETACHED' || buildings[i].attachmentType==='RIGHT_SEMI_DETACHED') && imageStructureRight.length<=0)
          messages.push('Please upload at least one photo for structure right.');
        if(state.upd.property.propertyType=='SF' && (buildings[i].attachmentType==='DETACHED' || buildings[i].attachmentType==='LEFT_SEMI_DETACHED') && imageStructureLeft.length<=0)
          messages.push('Please upload at least one photo for structure left.');
        let imageBuildingFront = !buildings[i].imageBuildingFront?[]:buildings[i].imageBuildingFront.slice();
        let imageBuildingRear = !buildings[i].imageBuildingRear?[]:buildings[i].imageBuildingRear.slice();
        

        if(state.upd.property.propertyType=='CONDO'){
          if(imageBuildingFront.length<=0)
            messages.push('Please upload at least one photo for the building front.');
          if(imageBuildingRear.length<=0)
            messages.push('Please upload at least one photo for the building rear.');
          let imageBuildingLeft = !buildings[i].imageBuildingLeft?[]:buildings[i].imageBuildingLeft.slice();
          let imageBuildingRight = !buildings[i].imageBuildingRight?[]:buildings[i].imageBuildingRight.slice();
          if((buildings[i].attachmentType==='DETACHED' || buildings[i].attachmentType==='RIGHT_SEMI_DETACHED') && imageBuildingLeft.length<=0)
            messages.push('Please upload at least one photo for building left.');
          if((buildings[i].attachmentType==='DETACHED' || buildings[i].attachmentType==='LEFT_SEMI_DETACHED') && imageBuildingRight.length<=0)
            messages.push('Please upload at least one photo for building right.');
        }

        let exteriorDeficiencies = !buildings[i].exteriorDeficiencies?[]:buildings[i].exteriorDeficiencies.slice();
        for(let x=0;x<exteriorDeficiencies.length;x++){
          if(exteriorDeficiencies[x].exteriorDeficiencyName.includes('NONE'))
            continue;
          let imageExteriorDeficiency = exteriorDeficiencies[x].imageExteriorDeficiency?exteriorDeficiencies[x].imageExteriorDeficiency.slice():[];
          if(imageExteriorDeficiency.length<=0)
            messages.push('Please upload at least one photo for each exterior deficiency.');
        }
        let exteriorUpdates = !buildings[i].exteriorUpdates?[]:buildings[i].exteriorUpdates.slice();
        for(let x=0;x<exteriorUpdates.length;x++){
          if(exteriorUpdates[x].exteriorUpdatedComponent.includes('NONE'))
            continue;
          let imageExteriorUpdate = exteriorUpdates[x].imageExteriorUpdate?exteriorUpdates[x].imageExteriorUpdate.slice():[];
          if(imageExteriorUpdate.length<=0)
            messages.push('Please upload at least one photo for each exterior update.');
        }
        let condoCarStorages = !buildings[i].condoCarStorages?[]:buildings[i].condoCarStorages.slice();
        for(let x=0;x<condoCarStorages.length;x++){
          let carStorage = condoCarStorages[x];
          if(condoCarStorages[x].condoCarStorageType.includes('NONE'))
            continue;
          let imageOutsideGarage = condoCarStorages[x].imageOutsideGarage?condoCarStorages[x].imageOutsideGarage.slice():[];
          let imageInsideGarage = condoCarStorages[x].imageInsideGarage?condoCarStorages[x].imageInsideGarage.slice():[];

          if(carStorage.condoCarStorageType==='DETACHED_GARAGE' || carStorage.condoCarStorageType==='ATTACHED_GARAGE' ||carStorage.condoCarStorageType==='BUILTIN_GARAGE'){
            if(imageOutsideGarage.length<=0)
              messages.push('Please upload at least one photo for the car storage exterior.');
            if(imageInsideGarage.length<=0)
              messages.push('Please upload at least one photo for the car storage interior.');
          }
          let imageCarport = condoCarStorages[x].imageCarport?condoCarStorages[x].imageCarport.slice():[];
          let imageOpenAssigned = condoCarStorages[x].imageOpenAssigned?condoCarStorages[x].imageOpenAssigned.slice():[];

          if(carStorage.condoCarStorageType==='CARPORT' && (props.upd.property.buildings[props.index].buildingDesign==='LOW_RISE'||props.upd.property.buildings[props.index].buildingDesign==='MID_RISE'||props.upd.property.buildings[props.index].buildingDesign==='HIGH_RISE') && imageCarport.length<=0)
            messages.push('Please upload at least one photo for carport.');
          if(carStorage.condoCarStorageType==='OPEN_ASSIGNED' && (props.upd.property.buildings[props.index].buildingDesign==='LOW_RISE'||props.upd.property.buildings[props.index].buildingDesign==='MID_RISE'||props.upd.property.buildings[props.index].buildingDesign==='HIGH_RISE') && imageOpenAssigned.length<=0)
            messages.push('Please upload at least one photo for open assign car storage.');

          let carStoragesDeficiencies = condoCarStorages[x].carStoragesDeficiencies?condoCarStorages[x].carStoragesDeficiencies.slice():[];

          for(let y=0;y<carStoragesDeficiencies.length;y++){
            if(carStoragesDeficiencies[y].condoCarStorageDeficiencyName.includes('NONE'))
              continue;
            let imageCondoCarStorageDeficiency = carStoragesDeficiencies[y].imageCondoCarStorageDeficiency?carStoragesDeficiencies[y].imageCondoCarStorageDeficiency.slice():[];
            if(imageCondoCarStorageDeficiency.length<=0)
              messages.push('Please upload at least one photo for condo car storage deficiency.');
          }
        }

        let units = buildings[i].units.slice();

        for(let j=0;j<units.length;j++){
            let unitFeatures = !units[j].unitFeatures?[]:units[j].unitFeatures.slice();

            for(let x=0;x<unitFeatures.length;x++){
              if(unitFeatures[x].featureType.includes('NONE'))
                continue;
              let imageFeatureType = unitFeatures[x].imageFeatureType?unitFeatures[x].imageFeatureType.slice():[];
              if(imageFeatureType.length<=0)
                messages.push('Please upload at least one photo for each unit feature.');
            }
            let mechanicalDeficiencies = !units[j].mechanicalDeficiencies.slice?[]:units[j].mechanicalDeficiencies.slice();
            let mechanicalUpdates = !units[j].mechanicalUpdates?[]:units[j].mechanicalUpdates.slice();

            for(let x=0;x<mechanicalDeficiencies.length;x++){
              if(mechanicalDeficiencies[x].mechanicalDeficiencyName.includes('NONE'))
                continue;
              let imageMechanicalDeficiency = mechanicalDeficiencies[x].imageMechanicalDeficiency?mechanicalDeficiencies[x].imageMechanicalDeficiency.slice():[];
              if(imageMechanicalDeficiency.length<=0)
                messages.push('Please upload at least one photo for each mechanical deficiency.');
            }

            for(let x=0;x<mechanicalUpdates.length;x++){
              if(mechanicalUpdates[x].mechanicalUpdatedComponent.includes('NONE'))
                continue;
              let imageMechanicalUpdate = mechanicalUpdates[x].imageMechanicalUpdate?mechanicalUpdates[x].imageMechanicalUpdate.slice():[];
              if(imageMechanicalUpdate.length<=0)
                messages.push('Please upload at least one photo for each mechanical update.');
            }

            let condoUnitViews = !units[j].unitView.views?[]:units[j].unitView.views.slice();
            for(let x=0;x<condoUnitViews.length;x++){
              if(condoUnitViews[x].unitViewDescriptionType.includes('NONE'))
                continue;
              let imageView = condoUnitViews[x].imageView?condoUnitViews[x].imageView.slice():[];
              if(imageView.length<=0)
                messages.push('Please upload at least one photo for each condo unit view.');
            }

            //GARAGE
            let garages = units[j].garages.slice();
            for(let x=0;x<garages.length;x++){
              if(garages[x].garageType.includes('NONE'))
                continue;

                let imageOutsideGarage = garages[x].imageOutsideGarage?garages[x].imageOutsideGarage.slice():[];
                let imageInsideGarage = garages[x].imageInsideGarage?garages[x].imageInsideGarage.slice():[];

                if(imageOutsideGarage.length<=0)
                  messages.push('Please upload at least one photo for each garage exterior.');

                if(imageInsideGarage.length<=0)
                  messages.push('Please upload at least one photo for each garage interior.');

                let garageDeficiencies = garages[x].garageDeficiencies.slice();
                for(let y=0;y<garageDeficiencies.length;y++){
                  if(garageDeficiencies[y].garageDeficiencyName.includes('NONE'))
                    continue;
                    let imageGarageDeficiency = garageDeficiencies[y].imageGarageDeficiency?garageDeficiencies[y].imageGarageDeficiency.slice():[];
                    if(imageGarageDeficiency.length<=0)
                      messages.push('Please upload at least one photo for each garage deficiency.');
                }
            }
                
            let levels = units[j].levels.slice();
            for(let k=0;k<levels.length;k++){
                let rooms = levels[k].rooms.slice();

                for(let m=0;m<rooms.length;m++){
                  let imageRoom = rooms[m].imageRoom?rooms[m].imageRoom.slice():[];
                  let imageLivingroom = rooms[m].imageLivingroom?rooms[m].imageLivingroom.slice():[];
                  let imageKitchen = rooms[m].imageKitchen?rooms[m].imageKitchen.slice():[];
                  let imageBathroom = rooms[m].imageBathroom?rooms[m].imageBathroom.slice():[];
                  let imageOven = rooms[m].imageOven?rooms[m].imageOven.slice():[];
                  let interiorDeficiencies = rooms[m].interiorDeficiencies?rooms[m].interiorDeficiencies.slice():[];
                  let interiorUpdates = rooms[m].interiorUpdates?rooms[m].interiorUpdates.slice():[];

                  if(rooms[m].roomType==='LIVING_ROOM'){
                    if(imageLivingroom.length<2)
                      messages.push('Please upload at least two photo for room #'+(m+1)+' at unit #'+(j+1)+' of level #'+(k+1));
                  }
                  else if(rooms[m].roomType==='KITCHEN'){
                    console.log(imageKitchen)
                    if(imageKitchen.length<2)
                      messages.push('Please upload at least two photo for room #'+(m+1)+' at unit #'+(j+1)+' of level #'+(k+1));
                    if(rooms[m].appliances.rangeOvenExists==='True' && imageOven.length<2)
                      messages.push('Please upload at least two photo for oven at room #'+(m+1)+' at unit #'+(j+1)+' of level #'+(k+1));
                  }
                  else if(rooms[m].roomType.includes('_BATH')){
                    if(imageBathroom.length<2)
                      messages.push('Please upload at least two photo for room #'+(m+1)+' at unit #'+(j+1)+' of level #'+(k+1));
                  }
                  else{
                    if(imageRoom.length<2)
                      messages.push('Please upload at least two photo for room #'+(m+1)+' at unit #'+(j+1)+' of level #'+(k+1));
                  }

                  for(let n=0;n<interiorDeficiencies.length;n++){
                    if(interiorDeficiencies[n].interiorDeficiencyName.includes('NONE'))
                      continue;
                    let imageDeficiency = interiorDeficiencies[n].imageDeficiency?interiorDeficiencies[n].imageDeficiency.slice():[];
                    if(imageDeficiency.length<=0)
                      messages.push('Please upload at least one photo for each room deficiency at room #'+(m+1)+' at unit #'+(j+1)+' of level #'+(k+1));
                  }

                  for(let n=0;n<interiorUpdates.length;n++){
                    if(interiorUpdates[n].interiorUpdatedComponent.includes('NONE'))
                      continue;
                    let imageUpdate = interiorUpdates[n].imageUpdate?interiorUpdates[n].imageUpdate.slice():[];
                    if(imageUpdate.length<=0)
                      messages.push('Please upload at least one photo for room update at room #'+(m+1)+' at unit #'+(j+1)+' of level #'+(k+1)+' '+rooms[m].roomType);
                  }
                }
            }
        }
    }

    return messages;
  }

  function isValidYear(year) {
    const currentYear = new Date().getFullYear();
    const parsedYear = parseInt(year, 10);

    return !isNaN(parsedYear) && parsedYear > 0 && parsedYear <= currentYear;
}

  // SECTION
  // General Report & Property Info
  // Site
  // Photos
  // Property Utilities & Ancillary
  // Data Collector Certification
  const finalCheck = ()=>{
    let messages = [];
    let upd = Object.assign({}, state.upd);

    if(upd.platform==='FNM' && upd.caseFileID.length!==10)
      messages.push('The case file ID should be exactly 10 digits [General Report & Property Info]');
    if(upd.collectionType==='')
      messages.push('Please specify the collection type [General Report & Property Info]');
    if(upd.propertyDataCollectorName==='')
      messages.push('Please fill in data collector name [Data Collector Certification]');
    if(upd.contactMethod==='')
      messages.push('Please provide the data collector contact information [Data Collector Certification]');
    if(upd.contactDetail==='')
      messages.push('Please provide the data collector contact information [Data Collector Certification]');
    if(upd.pdaCollectionEntity==='')
      messages.push('Please provide the data collector company name [Data Collector Certification]');
    if(upd.propertyDataCollectorType==='')
      messages.push('Please specify data collector type [Data Collector Certification]');
    if(upd.propertyDataCollectorType==='OTHER' && upd.propertyDataCollectorTypeDescription==='')
      messages.push('Please specify data collector type description [Data Collector Certification]');
    if(upd.dataCollectionDate==='')
      messages.push('Please specify the date data collected [Data Collector Certification]');
    if(upd.property.propertyType==='')
      messages.push('Please specify the property type [General Report & Property Info]');
    if(upd.property.propertyOccupied==='')
      messages.push('Please specify the property occupancy [General Report & Property Info]');
    if(upd.property.streetAddress==='')
      messages.push('Please specify the street address [General Report & Property Info]');
    if(upd.property.city==='')
      messages.push('Please specify the city [General Report & Property Info]');
    if(upd.property.state==='')
      messages.push('Please specify the state [General Report & Property Info]');
    if(upd.property.postalCode==='')
      messages.push('Please specify the zip code [General Report & Property Info]');


    // SF
    if(upd.property.propertyType==='SF'){
      if(upd.property.site.lot.lotSize==='')
        messages.push('Please specify the property lot size [General Report & Property Info]');
      if(upd.property.site.lot.lotSizeUnits==='')
        messages.push('Please specify the property lot size units [General Report & Property Info]');

      // VIEW
      let views = upd.property.site.siteFeature.siteView.views.slice();
      if(views.length<=0)
        messages.push('Please specify the view type [General Report & Property Info]');
      for(let i=0;i<views.length;i++){
        if(views[i].viewDescriptionType==='')
          messages.push('Please specify the view type [General Report & Property Info]');
        if(views[i].viewDescriptionType!=='NONE_NOTABLE'){
          if(views[i].viewQuality==='')
          messages.push('Please specify the view exposure [General Report & Property Info]');
          if(views[i].viewDescriptionDetails==='')
            messages.push('Please specify the view description [General Report & Property Info]');
        }
      }

      // PROPERTY IMPROVEMENT
      let propertyImprovements = upd.property.site.siteFeature.propertyImprovements.slice();
      if(propertyImprovements.length<=0)
        messages.push('Please specify the property improvement type [General Report & Property Info]');
      for(let i=0;i<propertyImprovements.length;i++){
        if(propertyImprovements[i].propertyImprovementType==='')
          messages.push('Please specify the property improvement type [General Report & Property Info]');
        if(propertyImprovements[i].propertyImprovementType!=='NONE' && propertyImprovements[i].propertyImprovementDescription==='')
          messages.push('Please specify the property improvement description [General Report & Property Info]');

        // INGROUND POOL
        let ingroundPoolConcerns = propertyImprovements[i].ingroundPoolConcerns?propertyImprovements[i].ingroundPoolConcerns.slice():[];
        if(propertyImprovements[i].propertyImprovementType==='INGROUND_POOL' && ingroundPoolConcerns.length<=0)
          messages.push('Please specify the inground pool concern type [General Report & Property Info]');
        for(let j=0;j<ingroundPoolConcerns.length;j++){
          if(ingroundPoolConcerns[j].poolConcernType==='')
            messages.push('Please specify the inground pool concern type [General Report & Property Info]');
          if(ingroundPoolConcerns[j].poolConcernType!=='NONE' && ingroundPoolConcerns[j].poolConcernDescription==='')
            messages.push('Please specify the inground pool concern description [General Report & Property Info]');
        }
      }

      // NON RESIDENTIAL USE
      let nonResidentialUses = upd.property.site.siteFeature.nonResidentialUses.slice();
      if(nonResidentialUses.length<=0)
        messages.push('Please specify the non-residential use type [General Report & Property Info]');
      for(let i=0;i<nonResidentialUses.length;i++){
        if(nonResidentialUses[i].nonResidentialUseType==='')
          messages.push('Please specify the non-residential use type [General Report & Property Info]');
        if(nonResidentialUses[i].nonResidentialUseType!=='NONE_OBSERVED' && nonResidentialUses[i].nonResidentialUseDescription==='')
          messages.push('Please specify the non-residential use description [General Report & Property Info]');
      }

    }

    // LOCATIONS
    let hasWaterfront = false;
    let locations = upd.property.site.siteFeature.location.locations.slice();
    if(locations.length<=0)
      messages.push('Please specify the location influences [General Report & Property Info]');
    for(let i=0;i<locations.length;i++){
      if(waterFrontList.indexOf(upd.property.site.siteFeature.location.locations[i].locationDescriptionType)!==-1){
        hasWaterfront = true;
      }
      if(locations[i].locationDescriptionType==='')
        messages.push('Please specify the location influences [General Report & Property Info]');
      if(locations[i].locationDescriptionDetails==='')
        messages.push('Please specify the location description [General Report & Property Info]');
    }

    // CONDITIONS
    let adverseSiteConditions = upd.property.site.siteFeature.adverseSiteConditions.slice();
    if(adverseSiteConditions.length<=0)
      messages.push('Please specify the adverse site factor [General Report & Property Info]');
    for(let i=0;i<adverseSiteConditions.length;i++){
      if(adverseSiteConditions[i].adverseType==='')
        messages.push('Please specify the adverse site factor [General Report & Property Info]');
    }

    // WATER FRONT SITE IMPROVEMENT
    if(upd.property.propertyType==='SF' && hasWaterfront){
      let waterfrontSiteImprovements = upd.property.site.siteFeature.waterfrontSiteImprovements.slice();
      if(waterfrontSiteImprovements.length<=0)
        messages.push('Please specify the water front improvement type [General Report & Property Info]');
      for(let i=0;i<waterfrontSiteImprovements.length;i++){
        if(waterfrontSiteImprovements[i].waterfrontImprovementType==='')
          messages.push('Please specify the water front improvement type [General Report & Property Info]');
      }
      if(waterfrontSiteImprovements.length<=0)
        messages.push('Please specify the water front improvement type [General Report & Property Info]');
    }
    
    // ROAD + ACCESS
    if(upd.property.site.offSiteFeature.road.roadOwnershipType==='')
      messages.push('Please specify the road ownership [Property Utilities & Ancillary]');
    if((upd.property.site.offSiteFeature.road.roadOwnershipType==='UNKNOWN'||upd.property.site.offSiteFeature.road.roadOwnershipType==='PRIVATE') && upd.property.site.offSiteFeature.road.roadMaintainedIndicator==='')
      messages.push('Please specify the road maintenance [Property Utilities & Ancillary]');
    if(upd.property.site.offSiteFeature.road.yearRoundAccessIndicator==='')
      messages.push('Please specify the property accessible year round [Property Utilities & Ancillary]');


    // UTILITIES
    let electricalServices = upd.property.site.siteUtility.electricalServices.slice();
    if(electricalServices.length<=0)
      messages.push('Please specify the electrical services [Property Utilities & Ancillary]');
    for(let i=0;i<electricalServices.length;i++){
      if((electricalServices[i].electricalType==='SOLAR'||electricalServices[i].electricalType==='WIND'||electricalServices[i].electricalType==='GENERATOR'||electricalServices[i].electricalType==='HYDRO_ELECTRIC') && electricalServices[i].offGridService==='')
        messages.push('Please specify if the electrical services is offgrid [Property Utilities & Ancillary]');
      if(electricalServices[i].electricalType==='')
        messages.push('Please specify if the electrical services [Property Utilities & Ancillary]');
    }

    let sewerServices = upd.property.site.siteUtility.sewerServices.slice();
    if(sewerServices.length<=0)
      messages.push('Please specify the sewer services [Property Utilities & Ancillary]');
    for(let i=0;i<sewerServices.length;i++){
      if(sewerServices[i].sewerType==='')
        messages.push('Please specify if the sewer services [Property Utilities & Ancillary]');
    }

    let waterServices = upd.property.site.siteUtility.waterServices.slice();
    if(waterServices.length<=0)
      messages.push('Please specify the water services [Property Utilities & Ancillary]');
    for(let i=0;i<waterServices.length;i++){
      if(waterServices[i].waterType==='')
        messages.push('Please specify if the water services [Property Utilities & Ancillary]');
    }

    let gasServices = upd.property.site.siteUtility.gasServices.slice();
    if(gasServices.length<=0)
      messages.push('Please specify the gas services [Property Utilities & Ancillary]');
    for(let i=0;i<gasServices.length;i++){
      if(gasServices[i].gasType==='')
        messages.push('Please specify if the gas services [Property Utilities & Ancillary]');
    }

    // BUILDING
    let buildings = upd.property.buildings.slice();
    if(buildings.length<=0)
        messages.push('Please include at least 1 building [Site]');
    for(let i=0;i<buildings.length;i++){
      // EXTERIOR DEFICIENCY
      let exteriorDeficiencies = buildings[i].exteriorDeficiencies?buildings[i].exteriorDeficiencies.slice():[];
      if(exteriorDeficiencies.length<=0)
        messages.push('Please specify the building exterior deficiency [Site]');
      for(let x=0;x<exteriorDeficiencies.length;x++){
        if(exteriorDeficiencies[x].exteriorDeficiencyName==='')
          messages.push('Please specify the building exterior deficiency [Site]');
        if(exteriorDeficiencies[x].exteriorDeficiencyName!=='NONE_OBSERVED' && exteriorDeficiencies[x].exteriorDeficiencyType==='')
          messages.push('Please specify the building exterior deficiency type [Site]');
        if(exteriorDeficiencies[x].exteriorDeficiencyName==='FOUNDATION' && (!exteriorDeficiencies[x].exteriorDeficiencyDetailFoundation || exteriorDeficiencies[x].exteriorDeficiencyDetailFoundation.length<=0))
          messages.push('Please specify the building exterior deficiency details [Site]');
        if(exteriorDeficiencies[x].exteriorDeficiencyName==='EXTERIOR_WALLS' && (!exteriorDeficiencies[x].exteriorDeficiencyDetailExteriorWalls || exteriorDeficiencies[x].exteriorDeficiencyDetailExteriorWalls.length<=0))
          messages.push('Please specify the building exterior deficiency details [Site]');
        if(exteriorDeficiencies[x].exteriorDeficiencyName==='ROOF' && (!exteriorDeficiencies[x].exteriorDeficiencyDetailRoofSurface || exteriorDeficiencies[x].exteriorDeficiencyDetailRoofSurface.length<=0))
          messages.push('Please specify the building exterior deficiency details [Site]');
        if(exteriorDeficiencies[x].exteriorDeficiencyName==='GUTTERS_DOWNSPOUT' && (!exteriorDeficiencies[x].exteriorDeficiencyDetailGuttersandDownspouts || exteriorDeficiencies[x].exteriorDeficiencyDetailGuttersandDownspouts.length<=0))
          messages.push('Please specify the building exterior deficiency details [Site]');
        if(exteriorDeficiencies[x].exteriorDeficiencyName==='WINDOWS' && (!exteriorDeficiencies[x].exteriorDeficiencyDetailWindows || exteriorDeficiencies[x].exteriorDeficiencyDetailWindows.length<=0))
          messages.push('Please specify the building exterior deficiency details [Site]');
        if(exteriorDeficiencies[x].exteriorDeficiencyName==='FOUNDATION' && exteriorDeficiencies[x].exteriorDeficiencyDetailFoundation==='')
          messages.push('Please specify the building exterior deficiency details [Site]');
        if(exteriorDeficiencies[x].exteriorDeficiencyName!=='NONE_OBSERVED' && exteriorDeficiencies[x].exteriorDeficiencySeverity==='')
          messages.push('Please specify the building exterior deficiency severity [Site]');
        if(exteriorDeficiencies[x].exteriorDeficiencyName!=='NONE_OBSERVED' && exteriorDeficiencies[x].exteriorDeficiencyDescription==='')
          messages.push('Please specify the building exterior deficiency description [Site]');
      }

      // EXTERIOR UPDATED COMPONENT
      let exteriorUpdates = buildings[i].exteriorUpdates?buildings[i].exteriorUpdates.slice():[];
      if(exteriorUpdates.length<=0)
        messages.push('Please specify the building exterior updated component [Site]');
      for(let x=0;x<exteriorUpdates.length;x++){
        if(exteriorUpdates[x].exteriorUpdatedComponent==='')
          messages.push('Please specify the building exterior deficiency [Site]');
        if(exteriorUpdates[x].exteriorUpdatedComponent!=='NONE_OBSERVED' && exteriorUpdates[x].exteriorUpdateType==='')
          messages.push('Please specify the building exterior updated component type [Site]');
        if(exteriorUpdates[x].exteriorUpdatedComponent!=='NONE_OBSERVED' && exteriorUpdates[x].exteriorUpdateTimeframe==='')
          messages.push('Please specify the building exterior updated component time frame [Site]');
        if(exteriorUpdates[x].exteriorUpdatedComponent!=='NONE_OBSERVED' && exteriorUpdates[x].exteriorUpdateDescription==='')
          messages.push('Please specify the building exterior updated component description [Site]');
      }
      
      let units = buildings[i].units.slice();
      if(units.length<=0)
        messages.push('Please include at least 1 unit [Site]');

      if(upd.property.propertyType==='SF' && buildings[i].structureType==='')
        messages.push('Please specify if the building structure type [Site]');
      if(upd.property.propertyType==='SF' && buildings[i].structureArea==='')
        messages.push('Please specify if the structure area [Site]');
      if((upd.property.propertyType==='CONDO'||(buildings[i].structureType==='DWELLING' && upd.property.propertyType==='SF')) && buildings[i].attachmentType==='')
        messages.push('Please specify if the attachment type [Site]');
      if((buildings[i].buildingDesign==='DETACHED'|| buildings[i].buildingDesign==='ROWHOUSE_TOWNHOUSE' || upd.property.propertyType==='SF') && (buildings[i].foundationType && buildings[i].foundationType.length<=0))
        messages.push('Please specify if the foundation type [Site]');
      if(buildings[i].constructionStatus==='')
        messages.push('Please specify if the construction status [Site]');
      if(upd.property.propertyType==='SF' && buildings[i].constructionType==='')
        messages.push('Please specify if the construction type [Site]');
      if(buildings[i].containsRooms==='')
        messages.push('Please specify if the building structure contains any room [Site]');
      if((upd.property.propertyType==='CONDO'||(buildings[i].structureType==='DWELLING' && upd.property.propertyType==='SF')) && buildings[i].yearBuilt==='')
        messages.push('Please specify if the year built [Site]');
      if((upd.property.propertyType==='CONDO'||(buildings[i].structureType==='DWELLING' && upd.property.propertyType==='SF')) && !isValidYear(buildings[i].yearBuilt))
        messages.push('Year built is invalid.');
      if((upd.property.propertyType==='CONDO'||(buildings[i].structureType==='DWELLING' && upd.property.propertyType==='SF')) && buildings[i].yearBuiltEstimate==='')
        messages.push('Please specify if the year built is an estimation [Site]');

      // CONDO
      if(upd.property.propertyType==='CONDO'){
        if(buildings[i].numberOfStories==='')
          messages.push('Please specify number of stories [Site]');
        if(buildings[i].numberOfElevators==='')
          messages.push('Please specify number of elevator [Site]');
        if((buildings[i].buildingDesign==='GARDEN'||buildings[i].buildingDesign==='LOW_RISE'||buildings[i].buildingDesign==='MID_RISE'||buildings[i].buildingDesign==='HIGH_RISE') && buildings[i].condoOffstreetParkingAvailable==='')
          messages.push('Please specify if there are off street parking [Site]');


        // CONDO CAR STORAGE
        let condoCarStorages = buildings[i].condoCarStorages.slice();
        // if(condoCarStorages.length<=0)
        //   messages.push('Please specify the off street parking type [Site]');
        for(let x=0;x<condoCarStorages.length;x++){
          if(condoCarStorages[x].condoCarStorageType==='')
            messages.push('Please specify the off street parking type [Site]');
          if(condoCarStorages[x].condoCarStorageSpaceCount==='')
            messages.push('Please specify the off street parking count [Site]');

          // CONDO CAR STORAGE DEFICIENCY
          let carStoragesDeficiencies = condoCarStorages[x].carStoragesDeficiencies?condoCarStorages[x].carStoragesDeficiencies.slice():[];
          if((condoCarStorages[x].condoCarStorageType==='BUILTIN_GARAGE'||condoCarStorages[x].condoCarStorageType==='ATTACHED_GARAGE'||condoCarStorages[x].condoCarStorageType==='DETACHED_GARAGE') && carStoragesDeficiencies.length<=0)
            messages.push('Please specify the condo car storage deficiency [Site]');
          for(let y=0;y<carStoragesDeficiencies.length;y++){
            if(carStoragesDeficiencies[y].condoCarStorageDeficiencyName==='')
              messages.push('Please specify the condo car storage deficiency [Site]');
            if(carStoragesDeficiencies[y].condoCarStorageDeficiencyName!=='NONE_OBSERVED' && carStoragesDeficiencies[y].condoCarStorageDeficiencyType==='')
              messages.push('Please specify the condo car storage deficiency type [Site]');
            if(carStoragesDeficiencies[y].condoCarStorageDeficiencyName==='FOUNDATION' && carStoragesDeficiencies[y].condoCarStorageDeficiencyDetailFoundation==='')
              messages.push('Please specify the condo car storage deficiency details [Site]');
            if(carStoragesDeficiencies[y].condoCarStorageDeficiencyName==='EXTERIOR_WALLS' && carStoragesDeficiencies[y].condoCarStorageDeficiencyDetailExteriorWalls==='')
              messages.push('Please specify the condo car storage deficiency details [Site]');
            if(carStoragesDeficiencies[y].condoCarStorageDeficiencyName==='ROOF' && carStoragesDeficiencies[y].condoCarStorageDeficiencyDetailRoofSurface==='')
              messages.push('Please specify the condo car storage deficiency details [Site]');
            if(carStoragesDeficiencies[y].condoCarStorageDeficiencyName==='WINDOWS' && carStoragesDeficiencies[y].condoCarStorageDeficiencyDetailWindows==='')
              messages.push('Please specify the condo car storage deficiency details [Site]');
            if(carStoragesDeficiencies[y].condoCarStorageDeficiencyName==='CEILING' && carStoragesDeficiencies[y].condoCarStorageDeficiencyDetailCeiling==='')
              messages.push('Please specify the condo car storage deficiency details [Site]');
            if(carStoragesDeficiencies[y].condoCarStorageDeficiencyName==='INTERIOR_WALLS' && carStoragesDeficiencies[y].condoCarStorageDeficiencyDetailInteriorWalls==='')
              messages.push('Please specify the condo car storage deficiency details [Site]');
            if(carStoragesDeficiencies[y].condoCarStorageDeficiencyName!=='NONE_OBSERVED' && carStoragesDeficiencies[y].condoCarStorageDeficiencySeverity==='')
              messages.push('Please specify the condo car storage deficiency severity [Site]');
            if(carStoragesDeficiencies[y].condoCarStorageDeficiencyName!=='NONE_OBSERVED' && carStoragesDeficiencies[y].condoCarStorageDeficiencyDescription==='')
              messages.push('Please specify the condo car storage deficiency description [Site]');
          }
        }

        
      }
      if(buildings[i].buildingDesign==='OTHER' && buildings[i].buildingDesignDescription==='')
        messages.push('Please specify building design description [Site]');
      // UNITS
      for(let j=0;j<units.length;j++){
        
        
        if(buildings[i].containsRooms==='TRUE' && units[j].aduIndicator==='')
          messages.push('Please specify if this unit contains ADU [Site]');
        if(upd.property.propertyType==='CONDO'){
          if(units[j].unitConstructionStatus==='')
            messages.push('Please specify if this unit construction status [Site]');
          if(units[j].floorNumber==='')
            messages.push('Please specify the floor number of this unit [Site]');
          if(units[j].topFloor==='')
            messages.push('Please specify if this unit located on top floor [Site]');
          if((buildings[i].buildingDesign==='GARDEN'||buildings[i].buildingDesign==='LOW_RISE'||buildings[i].buildingDesign==='MID_RISE'||buildings[i].buildingDesign==='HIGH_RISE') && units[j].unitMainEntrance==='')
            messages.push('Please specify if floor of the main entrance [Site]');

          // VIEW
          let views = units[j].unitView.views.slice();
          if(views.length<=0)
            messages.push('Please specify the view [Site]');
          for(let x=0;x<views.length;x++){
            if(views[x].unitViewDescriptionType==='')
              messages.push('Please specify the view [Site]');
            if(views[x].unitViewDescriptionType!=='NONE_NOTABLE' && views[x].unitViewQuality==='')
              messages.push('Please specify the view quality [Site]');
            if(views[x].unitViewDescriptionType!=='NONE_NOTABLE' && views[x].unitViewDescriptionDetails==='')
              messages.push('Please specify the view details [Site]');
          }

          let unitFeatures = units[j].unitFeatures.slice();
          if(unitFeatures.length<=0)
            messages.push('Please specify the unit feature [Site]');
        }

        let heatingSystems = units[j].heatingSystems.slice();
        if(heatingSystems.length<=0)
          messages.push('Please specify the heating system [Site]');

        let coolingSystems = units[j].coolingSystems.slice();
        if(coolingSystems.length<=0)
          messages.push('Please specify the cooling system [Site]');

        // MECHANICAL DEFICIENCY
        let mechanicalDeficiencies = units[j].mechanicalDeficiencies.slice();
        if(mechanicalDeficiencies.length<=0)
          messages.push('Please specify the mechanical deficiency [Site]');
        for(let x=0;x<mechanicalDeficiencies.length;x++){
          if(mechanicalDeficiencies[x].mechanicalDeficiencyName==='')
            messages.push('Please specify the mechanical deficiency [Site]');
          if(mechanicalDeficiencies[x].mechanicalDeficiencyName!=='NONE_OBSERVED' && mechanicalDeficiencies[x].mechanicalDeficiencyType==='')
            messages.push('Please specify the mechanical deficiency type [Site]');
          if(mechanicalDeficiencies[x].mechanicalDeficiencyName!=='NONE_OBSERVED' && mechanicalDeficiencies[x].mechanicalDeficiencySeverity==='')
            messages.push('Please specify the mechanical deficiency severity [Site]');
          if(mechanicalDeficiencies[x].mechanicalDeficiencyName!=='NONE_OBSERVED' && mechanicalDeficiencies[x].mechanicalDeficiencyDescription==='')
            messages.push('Please specify the mechanical deficiency description [Site]');
        }


        // MECHANICAL UPDATES
        let mechanicalUpdates = units[j].mechanicalUpdates.slice();
        if(mechanicalUpdates.length<=0)
          messages.push('Please specify the mechanical deficiency [Site]');
        for(let x=0;x<mechanicalUpdates.length;x++){
          if(mechanicalUpdates[x].mechanicalUpdatedComponent==='')
            messages.push('Please specify the mechanical updated component [Site]');
          if(mechanicalUpdates[x].mechanicalUpdatedComponent!=='NONE_OBSERVED' && mechanicalUpdates[x].mechanicalUpdatedComponent==='')
            messages.push('Please specify the mechanical updated component type [Site]');
          if(mechanicalUpdates[x].mechanicalUpdatedComponent!=='NONE_OBSERVED' && mechanicalUpdates[x].mechanicalUpdateTimeframe==='')
            messages.push('Please specify the mechanical updated component time frame [Site]');
          if(mechanicalUpdates[x].mechanicalUpdatedComponent!=='NONE_OBSERVED' && mechanicalUpdates[x].mechanicalUpdateDescription==='')
            messages.push('Please specify the mechanical updated component description [Site]');
        }

        // GARAGE
        let garages = units[j].garages.slice();
        if((((buildings[i].buildingDesign==='DETACHED'|| buildings[i].buildingDesign==='ROWHOUSE_TOWNHOUSE' || buildings[i].buildingDesign==='OTHER')&& upd.property.propertyType==='CONDO') || upd.property.propertyType==='SF') && garages.length<=0)
          messages.push('Please specify the garage [Site]');
        for(let x=0;x<garages.length;x++){
          if(garages[x].garageType==='')
            messages.push('Please specify the garage type [Site]');
          if(garages[x].garageType!=='NONE' && garages[x].garageSpaceCount==='')
            messages.push('Please specify the garage space count [Site]');
          if(garages[x].garageType!=='NONE' && garages[x].garageSpaceArea==='')
            messages.push('Please specify the garage space area [Site]');
          if(garages[x].garageType!=='NONE' && garages[x].garageConversionIndicator==='')
            messages.push('Please specify if the garage has been converted [Site]');

          let garageDeficiencies = garages[x].garageDeficiencies?garages[x].garageDeficiencies.slice():[];
          if(garages[x].garageType!=='NONE' && garageDeficiencies.length<=0)
            messages.push('Please specify the garage deficiency [Site]');
          for(let y=0;y<garageDeficiencies.length;y++){
            if(garageDeficiencies[y].garageDeficiencyName!=='NONE_OBSERVED' && garageDeficiencies[y].garageDeficiencyType==='')
              messages.push('Please specify the garage deficiency type [Site]');
            if(garageDeficiencies[y].garageDeficiencyName==='FOUNDATION' && garageDeficiencies[y].garageDeficiencyDetailFoundation==='')
              messages.push('Please specify the garage deficiency detail [Site]');
            if(garageDeficiencies[y].garageDeficiencyName==='EXTERIOR_WALLS' && garageDeficiencies[y].garageDeficiencyDetailExteriorWalls==='')
              messages.push('Please specify the garage deficiency detail [Site]');
            if(garageDeficiencies[y].garageDeficiencyName==='ROOF' && garageDeficiencies[y].garageDeficiencyDetailRoofSurface==='')
              messages.push('Please specify the garage deficiency detail [Site]');
            if(garageDeficiencies[y].garageDeficiencyName==='WINDOWS' && garageDeficiencies[y].garageDeficiencyDetailWindows==='')
              messages.push('Please specify the garage deficiency detail [Site]');
            if(garageDeficiencies[y].garageDeficiencyName==='CEILING' && garageDeficiencies[y].garageDeficiencyDetailCeiling==='')
              messages.push('Please specify the garage deficiency detail [Site]');
            if(garageDeficiencies[y].garageDeficiencyName==='INTERIOR_WALLS' && garageDeficiencies[y].garageDeficiencyDetailInteriorWalls==='')
              messages.push('Please specify the garage deficiency detail [Site]');
            if(garageDeficiencies[y].garageDeficiencyName!=='NONE_OBSERVED' && garageDeficiencies[y].garageDeficiencySeverity==='')
              messages.push('Please specify the garage deficiency severity [Site]');
            if(garageDeficiencies[y].garageDeficiencyName!=='NONE_OBSERVED' && garageDeficiencies[y].garageDeficiencyDescription==='')
              messages.push('Please specify the garage deficiency description [Site]');
          }
        }
     

        let levels = units[j].levels.slice();
        if(levels.length<=0)
          messages.push('Please include at least 1 level [Site]');

        // LEVELS
        for(let k=0;k<levels.length;k++){
          if(!levels[k].imageFloorPlan || levels[k].imageFloorPlan.length<=0)
            messages.push('Please upload one floor plan for level '+(k+1))

          // for(let z=0;z<levels[j].gla.length;z++){
          //   if(levels[z].gla[z].width===''||levels[z].gla[z].length===''||levels[z].gla[z].sqft===''||levels[z].gla[z].sqft===''||levels[z].gla[z].name===''){
          //     messages.push('One or more of the GLA calculation is incomplete.');
          //   }
          //   else{
          //     if(parseFloat(levels[z].gla[z].width) * parseFloat(levels[z].gla[z].length)!==parseFloat(levels[z].gla[z].sqft))
          //       messages.push('GLA calculation is incorrect on '+levels[z].gla[z].name+' on unit '+(j+1)+' of level '+(k+1));
          //   }
          // }
          
          let rooms = levels[k].rooms.slice();
          let totalGLARoom = 0;
          for(let l=0;l<rooms.length;l++){
            if(rooms[l].roomType!=='UNFINISHED_BASEMENT')
              totalGLARoom++;
          }

          let totalGLACount = 0;
          for(let z = 0; z < levels[k].gla.length; z++){
            
            const glaCalculation = levels[k].gla[z];
            if (glaCalculation.common_area !== true && glaCalculation.common_area !== 'true')
              totalGLACount++;
            
            if(glaCalculation.irregular!== true && glaCalculation.irregular!== 'true'){
              if(glaCalculation.width === '' || glaCalculation.length === '' || glaCalculation.sqft === '' || glaCalculation.name === ''){
                messages.push('One or more of the GLA calculation is incomplete.');
              } else {
                let sqft = calculateSquareFeet(glaCalculation.width, glaCalculation.length);
                if(normalizeFeetInches(sqft)!=normalizeFeetInches(glaCalculation.sqft)){
                  messages.push('GLA calculation is incorrect on ' + glaCalculation.name + ' on unit ' + (j+1) + ' of level ' + (k+1)+' '+normalizeFeetInches(sqft)+' vs '+glaCalculation.sqft);
                }
              }
            }
            else{
              if(glaCalculation.sqft === '' || glaCalculation.name === ''){
                messages.push('One or more of the GLA calculation is incomplete.');
              }
            }
          }
          console.log('k =', k, 'k+1 =', k + 1);

          if(totalGLACount!==totalGLARoom) {
            messages.push('The entries on GLA is not matching with room count on building #'+(i+1)+' unit #'+(j+1)+' level #'+(k+1)+'. Please make sure you use the common area checkbox for common area that is not a room.');
          }

          
          
          // total area not matching with finished and non finished
          let totalArea = parseInt(levels[k].totalArea,10);
          let finishedArea = parseInt(levels[k].finishedArea,10);
          let nonStandardFinishedArea = parseInt(levels[k].nonStandardFinishedArea,10);
          let unfinishedArea = parseInt(levels[k].unfinishedArea,10);
       
          if(unfinishedArea+finishedArea+nonStandardFinishedArea!==totalArea)
            messages.push('The sum of finished area, non finished standard area and unfinished area is not equal to your total area on level '+(k+1));

          if(levels[k].levelNumber==='')
            messages.push('Please specify the level number [Site]');
          if(levels[k].belowGrade==='')
            messages.push('Please specify the level is below grade [Site]');
          if(levels[k].belowGrade==='TRUE' && levels[k].belowGradeExits==='')
            messages.push('Please specify the below grade exits [Site]');
          if(levels[k].levelLowCeiling==='')
            messages.push('Please specify if ceiling is low than 7ft above floor [Site]');
          if(levels[k].attic==='')
            messages.push('Please specify if attic can be accessed [Site]');
          if(levels[k].attic==='TRUE' && levels[k].atticAccess==='')
            messages.push('Please specify the attic access [Site]');
          if(levels[k].totalArea==='')
            messages.push('Please specify the total area of this level [Site]');
          if(levels[k].finishedArea==='')
            messages.push('Please specify the total finished area of this level [Site]');
          if(levels[k].nonStandardFinishedArea==='')
            messages.push('Please specify the non standard finished area of this level [Site]');

          if(rooms.length<=0)
            messages.push('Please include at least 1 room [Site]');

          // ROOMS
          for(let l=0;l<rooms.length;l++){
            if(rooms[l].roomType==='')
              messages.push('Please specify the room type [Site]');
            if(rooms[l].roomType==='OTHER_ROOM' && rooms[l].otherRoomTypeDescription==='')
              messages.push('Please specify the room description [Site]');
            if(rooms[l].roomType==='KITCHEN' && rooms[l].rangeOvenExists)
              messages.push('Please specify if the kitchen has range oven [Site]');

            let fixtureTypes = rooms[l].plumbingFixtures.slice();
            if((rooms[l].roomType==='FULL_BATH'||rooms[l].roomType==='HALF_BATH'||rooms[l].roomType==='KITCHEN'||rooms[l].roomType==='BUTLERS_PANTRY'||rooms[l].roomType==='LAUNDRY_ROOM') && fixtureTypes.length<=0)
              messages.push('Please specify the room fixture types [Site]');
            let roomFeatures = rooms[l].roomFeatures[0].roomFeatureType.slice();
            if(roomFeatures.length<=0)
              messages.push('Please specify the room features [Site]');

            let interiorDeficiencies = rooms[l].interiorDeficiencies.slice();
            let interiorUpdates = rooms[l].interiorUpdates.slice();

            if(interiorDeficiencies.length<=0)
              messages.push('Please specify the room interior deficiency [Site]');
            for(let x=0;x<interiorDeficiencies.length;x++){
              if(interiorDeficiencies[x].interiorDeficiencyName!=='NONE_OBSERVED' && interiorDeficiencies[x].interiorDeficiencyType==='')
                messages.push('Please specify the room interior deficiency type [Site]');
              if(interiorDeficiencies[x].interiorDeficiencyName==='FLOORING' && interiorDeficiencies[x].interiorDeficiencyDetailFlooring==='')
                messages.push('Please specify the room interior deficiency detail [Site]');
              if(interiorDeficiencies[x].interiorDeficiencyName==='CEILING' && interiorDeficiencies[x].interiorDeficiencyDetailCeiling==='')
                messages.push('Please specify the room interior deficiency detail [Site]');
              if(interiorDeficiencies[x].interiorDeficiencyName==='WALLS' && interiorDeficiencies[x].interiorDeficiencyDetailWalls==='')
                messages.push('Please specify the room interior deficiency detail [Site]');
              if(interiorDeficiencies[x].interiorDeficiencyName==='SHOWER_TUB_SURROUND' && interiorDeficiencies[x].interiorDeficiencyDetailTubShowerSurround==='')
                messages.push('Please specify the room interior deficiency detail [Site]');
              if(interiorDeficiencies[x].interiorDeficiencyName!=='NONE_OBSERVED' && interiorDeficiencies[x].interiorDeficiencySeverity==='')
                messages.push('Please specify the room interior deficiency severity [Site]');
              if(interiorDeficiencies[x].interiorDeficiencyName!=='NONE_OBSERVED' && interiorDeficiencies[x].interiorDeficiencyDescription==='')
                messages.push('Please specify the room interior deficiency description [Site]');
            }

            if(interiorUpdates.length<=0)
              messages.push('Please specify the room interior updated component [Site]');
            for(let x=0;x<interiorUpdates.length;x++){
              if(interiorUpdates[x].interiorUpdatedComponent!=='NONE_OBSERVED' && interiorUpdates[x].interiorUpdateType==='')
                messages.push('Please specify the room interior updated component type [Site]');
              if(interiorUpdates[x].interiorUpdatedComponent!=='NONE_OBSERVED' && interiorUpdates[x].interiorUpdateTimeframe==='')
                messages.push('Please specify the room interior updated component time frame [Site]');
              if(interiorUpdates[x].interiorUpdatedComponent!=='NONE_OBSERVED' && interiorUpdates[x].interiorUpdateDescription==='')
                messages.push('Please specify the room interior updated component description [Site]');
            }
          }
        }
      }
    }

    if((!state.upd.signature.draw || state.upd.signature.draw==='' )&& (!state.upd.signature.upload || state.upd.signature.upload==='')){
      messages.push('Please sign the report or upload your signature with a photo.');
    }
    if(!state.upd.dataCollectorAcknowledgement){
      messages.push('Please check the checkbox for statement and agreenment.');
    }

    // PHOTO
    let messages2 = finalCheckPhoto();
    messages = messages.concat(messages2);
    return messages;
  }

  const updateStep = (step)=>{
    if(ReactDOM.findDOMNode(this)&&ReactDOM.findDOMNode(this).parentElement)
      ReactDOM.findDOMNode(this).parentElement.scrollTop = 0;
    if(step<=parseInt(state.maxStep,10)+1){
      setState({currentStep:step});
    }
    if(step>state.maxStep)
      setState({maxStep:step});
    if(step===4)
      setState({reviewMessages:finalCheck()});
  }

  const deleteObjectsWithImages = (obj1)=> {
    function deleteImage(obj1) {
        let deleted;
        if(typeof obj1 !=='string'){
          deleted = {...obj1};
          for (let key in obj1) {
              if(key.startsWith('image')){
                delete deleted[key];
              }
              else if (typeof obj1[key] === 'object' && !Array.isArray(obj1[key]) && typeof obj1[key] !=='string') {
                deleted[key] = deleteImage(obj1[key]);
              } 
              else if(Array.isArray(obj1[key])){
                for(let i=0;i<obj1[key].length;i++){
                  deleted[key][i] = deleteImage(obj1[key][i])
                }
              }
          }
        } else{
          deleted = obj1;
        }
        return deleted;
    }
    
    return deleteImage(obj1);
  }

  const mergeObjectsWithImages = (obj1, obj2) => {
    function merge(obj1, obj2) {
        let merged;
        	if(typeof obj2 !=='string'){
          	if(Object.keys(obj1).length === 0)
        			merged = {...obj2};
            else
            	merged = {...obj1};
            for (let key in obj2) {
                if(!merged[key])
                  merged[key] = obj2[key];
                else if (typeof obj2[key] === 'object' && !Array.isArray(obj2[key]) && typeof obj2[key] !=='string') {
                  merged[key] = merge(obj1[key] || {}, obj2[key]);
                } 
                else if(Array.isArray(obj2[key])){
                  for(let i=0;i<obj2[key].length;i++){
                      merged[key][i] = merge(obj1[key][i] || {}, obj2[key][i])
                    }
                }else {
                  merged[key] = obj2[key];
                }
            }
          } else{
          	if(obj1!=='')
            	merged = obj2;
           	else
            	merged = obj1;
          }
          
         
        
        return merged;
    }
    
    return merge(obj1, obj2);
  }

  //API call
  const saveForm = (message='') => {
    if(state.loading || state.loadError){
      if(state.loading)
        showMessage('error', 'The form is still loading. Please wait until it has finished loading before saving.')
      else if(state.loadError)
        showMessage('error', 'The form failed to load. Please reload the report before saving.')
      return;
    }

    let parameters = [
      {
        field:'maxStep',
        value:state.maxStep
      },
      {
        field:'updFk',
        value:state.updFk?state.updFk:'1'
      }  
    ];
    let copyUPD = _.cloneDeep(state.upd);
    let property = {...copyUPD.property};
    let buildings = property.buildings.slice();

    copyUPD = deleteObjectsWithImages(copyUPD);
    delete copyUPD.property.photo;
    for(let i=0;i<buildings.length;i++){
      for (const [key, ] of Object.entries(buildings[i])) {
        if(key.startsWith('image'))
          delete buildings[i][key];
      }

      let units = buildings[i].units.slice();
      for(let j=0;j<units.length;j++){
        for (const [key, ] of Object.entries(units[j])) {
          if(key.startsWith('image'))
            delete units[j][key];
        }

        let levels = units[j].levels.slice();
        for(let k=0;k<levels.length;k++){
          for (const [key, ] of Object.entries(levels[k])) {
            if(key.startsWith('image'))
              delete levels[k][key];
          }
          
          let rooms = levels[k].rooms.slice();
          for(let l=0;l<rooms.length;l++){
            for (const [key, ] of Object.entries(rooms[l])) {
              if(key.startsWith('image'))
                delete rooms[l][key];
            }
          }
          levels[k].rooms = rooms;
          units[j].levels = levels;
        }
      }
      buildings[i].units = units;
    }
    copyUPD.property.buildings = buildings;
    for (const [key, value] of Object.entries(copyUPD)) {
      if(!key.startsWith('image'))
        parameters.push({field:key, value:value});
    }

    let callBack = (response)=>{
      let code= response.data.code;

      if(code==='00'){
        let upd = Object.assign({}, state.upd);
        
        let loadedUPD = response.data.data;
        let newUPD = mergeObjectsWithImages(upd, loadedUPD);
        newUPD.property.street = newUPD.property.address.streetAddress;

        let locations = newUPD.property.site.siteFeature.location.locations.slice();

        for(let i=0;i<locations.length;i++){
          if(!locations[i].imageBorder)
            locations[i].imageBorder = [];
          if(!locations[i].imageWaterFront)
            locations[i].imageWaterFront = [];
        }

        newUPD.property.site.siteFeature.location.locations = locations;

        if(newUPD.property.buildings.length<=0){
          newUPD.property.buildings = [{imageStructureFront:[], imageStructureRear:[], imageStructureLeft:[], imageStructureRight:[],imageBuildingFront:[], imageBuildingRear:[], imageBuildingLeft:[], imageBuildingRight:[],imageDwellingFront:[], imageDwellingRear:[], imageDwellingLeft:[], imageDwellingRight:[], condoCarStorages:[],exteriorDeficiencies:[],exteriorUpdates:[], units:[{unitView:{views:[]}, unitFeatures:[], heatingSystems:[], coolingSystems:[], mechanicalDeficiencies:[], mechanicalUpdates:[], garages:[], levels:[{gla:[], imageFloorPlan:[], belowGradeExits:[], atticAccess:[], rooms:[{imageRoom:[], imageKitchen:[], imageLivingroom:[], imageBathroom:[], imageOven:[], appliances:{},interiorUpdates:[], interiorDeficiencies:[], plumbingFixtures:[], roomFeatures:[{roomFeatureType:[]}]}]}]}]}];
        }
        else{
          let buildings = newUPD.property.buildings.slice();
          for(let i=0;i<buildings.length;i++){
            if(buildings[i].units.length<=0)
              buildings[i].units = [{unitView:{views:[]}, unitFeatures:[], heatingSystems:[], coolingSystems:[], mechanicalDeficiencies:[], mechanicalUpdates:[], garages:[], levels:[{gla:[], imageFloorPlan:[], belowGradeExits:[], atticAccess:[], rooms:[{imageRoom:[], imageKitchen:[], imageLivingroom:[], imageBathroom:[], imageOven:[], appliances:{},interiorUpdates:[], interiorDeficiencies:[], plumbingFixtures:[], roomFeatures:[{roomFeatureType:[]}]}]}]}];
          }
          newUPD.property.buildings = buildings;
        }

        newUPD.dataCollectorAcknowledgement = newUPD.dataCollectorAcknowledgement==="True";
        setState({upd:newUPD,action:'uploadPhoto'});
      }
    };
    console.log(parameters);
    httpPut('uniformPropertyDataset/update', parameters, message, 'Oops, something went wrong and could not save the report. Please try again later.', callBack);
  }

  const cancelUPD = ()=>{
    let parameters = [
      {
        field:'updFk',
        value:state.updFk
      },
      {
        field:'status',
        value:'Cancelled'
      },
    ];
    let callBack = ()=>{};

    httpPut('uniformPropertyDataset/status/update', parameters, 'UPD cancelled.', 'Oops, something went wrong and could not cancel the UPD. Please try again later.', callBack);
  }

  const getUPD = () => {
    setState({loading:true, loadError:false});

    let callBack = (response)=>{
      try{
        let code = response.data.code;
        if(code==='00'){
          //load the state with value
          let upd = Object.assign({}, state.upd);
          let loadedUPD = response.data.data;
          let newUPD = {...upd, ...loadedUPD};
          newUPD.property.street = newUPD.property.address.streetAddress;
      
          let locations = newUPD.property.site.siteFeature.location.locations.slice();

          for(let i=0;i<locations.length;i++){
            locations[i].imageBorder = [];
            locations[i].imageWaterFront = [];
          }

          newUPD.property.site.siteFeature.location.locations = locations;

          if(newUPD.property.buildings.length<=0){
            newUPD.property.buildings = [{imageStructureFront:[], imageStructureRear:[], imageStructureLeft:[], imageStructureRight:[],imageBuildingFront:[], imageBuildingRear:[], imageBuildingLeft:[], imageBuildingRight:[],imageDwellingFront:[], imageDwellingRear:[], imageDwellingLeft:[], imageDwellingRight:[], condoCarStorages:[],exteriorDeficiencies:[],exteriorUpdates:[], units:[{unitView:{views:[]}, unitFeatures:[], heatingSystems:[], coolingSystems:[], mechanicalDeficiencies:[], mechanicalUpdates:[], garages:[], levels:[{gla:[], imageFloorPlan:[], belowGradeExits:[], atticAccess:[], rooms:[{imageRoom:[], imageKitchen:[], imageLivingroom:[], imageBathroom:[], imageOven:[], appliances:{},interiorUpdates:[], interiorDeficiencies:[], plumbingFixtures:[], roomFeatures:[{roomFeatureType:[]}]}]}]}]}];
          }
          else{
            let buildings = newUPD.property.buildings.slice();
            for(let i=0;i<buildings.length;i++){
              if(buildings[i].units.length<=0)
                buildings[i].units = [{unitView:{views:[]}, unitFeatures:[], heatingSystems:[], coolingSystems:[], mechanicalDeficiencies:[], mechanicalUpdates:[], garages:[], levels:[{gla:[], imageFloorPlan:[], belowGradeExits:[], atticAccess:[], rooms:[{imageRoom:[], imageKitchen:[], imageLivingroom:[], imageBathroom:[], imageOven:[], appliances:{},interiorUpdates:[], interiorDeficiencies:[], plumbingFixtures:[], roomFeatures:[{roomFeatureType:[]}]}]}]}];
            }
            newUPD.property.buildings = buildings;
          }

          newUPD.dataCollectorAcknowledgement = newUPD.dataCollectorAcknowledgement==="True";

          setState({upd:newUPD, action:'loaded', loading:false, loadError:false});
          if(state.maxStep<parseInt(response.data.data.maxStep))
            setState({maxStep:response.data.data.maxStep});
        } else {
          setState({loading:false, loadError:true});
        }
      }
      catch(err){
        setState({loading:false, loadError:true});
      }
    };

     let errorCallBack = ()=>{
      setState({loading:false, loadError:true});
    };

    httpGet('uniformPropertyDataset/'+state.updFk, '', 'Oops, something went wrong and could not load this report. Please try again later.', callBack, errorCallBack);
  }

  const uploadPhoto = async (photo, updateCallBack) => {
    let parameters = [
      {
        field:'updFk',
        value:state.updFk
      },
      {
        field:'typeFk',
        value:photo.typeFk
      },
      {
        field:'type',
        value:photo.type
      },
      {
        field:'description',
        value:photo.description?photo.description:''
      },
      {
        field:'name',
        value:photo.name
      },
      {
        field:'size',
        value:photo.size
      },
      {
        field:'uploadedFile',
        value:photo.base64
      },
      {
        field:'uploaderName',
        value:state.name
      }
    ];

    let messageID = showMessage('non-dismissable','Uploading '+photo.name+', please do not close your browser.');
   
    let callBack = (response)=>{
      let code= response.data.code;

      hideMessage(messageID);
      if(code==='00'){
        let data = response.data.data;
        updateCallBack(data.ID);
      }
    };

    await httpPost('uniformPropertyDataset/photo/upload', parameters, '', 'Oops, something went wrong on uploading photo and could not save the report. Please try again later.', callBack);
  }

  const uploadPhotos = async ()=>{
    
    let callCounter = 0;

    //OTHER PHOTO
    callCounter = 0;
    let photos = state.upd.photos?state.upd.photos.slice():[];
    for(let i=0;i<photos.length;i++){
      //any photo with ID means it's already uploaded
      if(!photos[i].ID || photos[i].ID===-1){
        // eslint-disable-next-line no-loop-func
        let updateCallBack = (ID)=>{
          callCounter++;
          photos[i].ID = ID;
          if(callCounter>=photos.length){
            let upd = Object.assign({}, state.upd);
            upd.photos = photos;
            setState({upd:upd});
          }
        }

        await uploadPhoto(photos[i], updateCallBack);
      }
    }

    //Signature
    let signature = Object.assign({}, state.upd.signature);
    if(((signature.upload && signature.upload!=='')||(signature.draw && signature.draw!=='')) && !signature.status){
      let base64;
      if(signature.draw && signature.draw!=='')
        base64 = signature.draw;
      else
        base64 = signature.upload;

      let tmp = {
        type:'SIGNATURE',
        typeFk:0,
        base64:base64,
        name:'signature',
        uploaderName:state.dataCollectorName
      };

      let updateCallBack = (ID)=>{
        let upd = Object.assign({}, state.upd);
        signature.status='Done';
        upd.signature = signature;
        setState({upd:upd});
      }
      await uploadPhoto(tmp, updateCallBack);
    }

    //STREET NUMBER
    let imageStreetNumber = state.upd.imageStreetNumber?state.upd.imageStreetNumber.slice():[];
    for(let i=0;i<imageStreetNumber.length;i++){
      //any photo with ID means it's already uploaded
      if(!imageStreetNumber[i].ID || imageStreetNumber[i].ID===-1){
        // eslint-disable-next-line no-loop-func
        let updateCallBack = (ID)=>{
          callCounter++;
          imageStreetNumber[i].ID = ID;
          if(callCounter>=imageStreetNumber.length){
            let upd = Object.assign({}, state.upd);
            upd.imageStreetNumber = imageStreetNumber;
            setState({upd:upd});
          }
        }

        await uploadPhoto(imageStreetNumber[i], updateCallBack);
      }
    }

    //STREET NUMBER
    callCounter = 0;
    let imageUnitNumber = state.upd.imageUnitNumber?state.upd.imageUnitNumber.slice():[];
    for(let i=0;i<imageUnitNumber.length;i++){
      //any photo with ID means it's already uploaded
      if(!imageUnitNumber[i].ID || imageUnitNumber[i].ID===-1){
        // eslint-disable-next-line no-loop-func
        let updateCallBack = (ID)=>{
          callCounter++;
          imageUnitNumber[i].ID = ID;
          if(callCounter>=imageUnitNumber.length){
            let upd = Object.assign({}, state.upd);
            upd.imageUnitNumber = imageUnitNumber;
            setState({upd:upd});
          }
        }

        await uploadPhoto(imageUnitNumber[i], updateCallBack);
      }
    }

    //STREET NUMBER
    callCounter = 0;
    let imageStreetLeft = state.upd.imageStreetLeft?state.upd.imageStreetLeft.slice():[];
    for(let i=0;i<imageStreetLeft.length;i++){
      //any photo with ID means it's already uploaded
      if(!imageStreetLeft[i].ID || imageStreetLeft[i].ID===-1){
        // eslint-disable-next-line no-loop-func
        let updateCallBack = (ID)=>{
          callCounter++;
          imageStreetLeft[i].ID = ID;
          if(callCounter>=imageStreetLeft.length){
            let upd = Object.assign({}, state.upd);
            upd.imageStreetLeft = imageStreetLeft;
            setState({upd:upd});
          }
        }

        await uploadPhoto(imageStreetLeft[i], updateCallBack);
      }
    }

    //STREET NUMBER
    callCounter = 0;
    let imageStreetRight = state.upd.imageStreetRight?state.upd.imageStreetRight.slice():[];
    for(let i=0;i<imageStreetRight.length;i++){
      //any photo with ID means it's already uploaded
      if(!imageStreetRight[i].ID || imageStreetRight[i].ID===-1){
        // eslint-disable-next-line no-loop-func
        let updateCallBack = (ID)=>{
          callCounter++;
          imageStreetRight[i].ID = ID;
          if(callCounter>=imageStreetRight.length){
            let upd = Object.assign({}, state.upd);
            upd.imageStreetRight = imageStreetRight;
            setState({upd:upd});
          }
        }

        await uploadPhoto(imageStreetRight[i], updateCallBack);
      }
    }

    //ROAD
    callCounter = 0;
    let imageRoad = state.upd.imageRoad?state.upd.imageRoad.slice():[];
    for(let i=0;i<imageRoad.length;i++){
      //any photo with ID means it's already uploaded
      if(!imageRoad[i].ID || imageRoad[i].ID===-1){
        // eslint-disable-next-line no-loop-func
        let updateCallBack = (ID)=>{
          callCounter++;
          imageRoad[i].ID = ID;
          if(callCounter>=imageRoad.length){
            let upd = Object.assign({}, state.upd);
            upd.imageRoad = imageRoad;
            setState({upd:upd});
          }
        }

        await uploadPhoto(imageRoad[i], updateCallBack);
      }
    }

    //CONDITION
    let adverseSiteConditions = state.upd.property.site.siteFeature.adverseSiteConditions.slice();
    for(let i=0;i<adverseSiteConditions.length;i++){
      let imageCondition = adverseSiteConditions[i].imageCondition?adverseSiteConditions[i].imageCondition.slice():[];
      for(let j=0;j<imageCondition.length;j++){
        imageCondition[j].typeFk = adverseSiteConditions[i].ID;
        if(!imageCondition[j].ID || imageCondition[j].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageCondition[j].ID = ID;
            if(callCounter>=imageCondition.length){
              let upd = Object.assign({}, state.upd);
              upd.property.site.siteFeature.adverseSiteConditions[i].imageCondition = imageCondition;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageCondition[j], updateCallBack);
        }
      }
    }

    let views = state.upd.property.site.siteFeature.siteView.views?state.upd.property.site.siteFeature.siteView.views.slice():[];

    for(let i=0;i<views.length;i++){
      let imageView = views[i].imageView?views[i].imageView.slice():[];

      for(let j=0;j<imageView.length;j++){
        imageView[j].typeFk = views[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageView[j].ID || imageView[j].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageView[j].ID = ID;
            if(callCounter>=imageView.length){
              let upd = Object.assign({}, state.upd);
              upd.property.site.siteFeature.siteView.views[i].imageView = imageView;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageView[j], updateCallBack);
        }
      }
    }

    //LOCATIONS
    let locations = state.upd.property.site.siteFeature.location.locations.slice();
    for(let i=0;i<locations.length;i++){
      let imageBorder = locations[i].imageBorder?locations[i].imageBorder.slice():[];
      let imageWaterfront = locations[i].imageWaterFront?locations[i].imageWaterFront.slice():[];
   
      for(let j=0;j<imageBorder.length;j++){
        imageBorder[j].typeFk = locations[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageBorder[j].ID || imageBorder[j].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageBorder[j].ID = ID;
            if(callCounter>=imageBorder.length){
              let upd = Object.assign({}, state.upd);
              upd.property.site.siteFeature.location.locations[i].imageBorder = imageBorder;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageBorder[j], updateCallBack);
        }
      }

      for(let j=0;j<imageWaterfront.length;j++){
        imageWaterfront[j].typeFk = locations[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageWaterfront[j].ID || imageWaterfront[j].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageWaterfront[j].ID = ID;
            if(callCounter>=imageWaterfront.length){
              let upd = Object.assign({}, state.upd);
              upd.property.site.siteFeature.location.locations[i].imageWaterfront = imageWaterfront;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageWaterfront[j], updateCallBack);
        }
      }
    }
    
    let waterfrontSiteImprovements = state.upd.property.site.siteFeature.waterfrontSiteImprovements.slice();
    for(let i=0;i<waterfrontSiteImprovements.length;i++){
      let imageWaterfrontImprovement = waterfrontSiteImprovements[i].imageWaterfrontImprovement?waterfrontSiteImprovements[i].imageWaterfrontImprovement.slice():[];

      for(let j=0;j<imageWaterfrontImprovement.length;j++){
        imageWaterfrontImprovement[j].typeFk = waterfrontSiteImprovements[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageWaterfrontImprovement[j].ID || imageWaterfrontImprovement[j].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageWaterfrontImprovement[j].ID = ID;
            if(callCounter>=imageWaterfrontImprovement.length){
              let upd = Object.assign({}, state.upd);
              upd.property.site.siteFeature.waterfrontSiteImprovements[i].imageWaterfrontImprovement = imageWaterfrontImprovement;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageWaterfrontImprovement[j], updateCallBack);
        }
      }
    }

    let propertyImprovements = state.upd.property.site.siteFeature.propertyImprovements.slice();
    for(let i=0;i<propertyImprovements.length;i++){
      let imagePropertyImprovement = propertyImprovements[i].imagePropertyImprovement?propertyImprovements[i].imagePropertyImprovement.slice():[];
      let ingroundPoolConcerns = propertyImprovements[i].ingroundPoolConcerns?propertyImprovements[i].ingroundPoolConcerns.slice():[];
      
      for(let j=0;j<ingroundPoolConcerns.length;j++){
        let imagePoolConcern = ingroundPoolConcerns[j].imagePoolConcern?ingroundPoolConcerns[j].imagePoolConcern.slice():[];

        for(let k=0;k<imagePoolConcern.length;k++){
          imagePoolConcern[k].typeFk = ingroundPoolConcerns[j].ID;
          //any photo with ID means it's already uploaded
          if(!imagePoolConcern[k].ID || imagePoolConcern[k].ID===-1){
            // eslint-disable-next-line no-loop-func
            let updateCallBack = (ID)=>{
              callCounter++;
              imagePoolConcern[k].ID = ID;
              if(callCounter>=imagePoolConcern.length){
                let upd = Object.assign({}, state.upd);
                upd.property.site.siteFeature.propertyImprovements[i].ingroundPoolConcerns[j].imagePoolConcern = imagePoolConcern;
                setState({upd:upd});
              }
            }

            await uploadPhoto(imagePoolConcern[k], updateCallBack);
          }
        }
      }

      for(let j=0;j<imagePropertyImprovement.length;j++){
        imagePropertyImprovement[j].typeFk = propertyImprovements[i].ID;
        //any photo with ID means it's already uploaded
        if(!imagePropertyImprovement[j].ID || imagePropertyImprovement[j].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imagePropertyImprovement[j].ID = ID;
            if(callCounter>=imagePropertyImprovement.length){
              let upd = Object.assign({}, state.upd);
              upd.property.site.siteFeature.propertyImprovements[i].imagePropertyImprovement = imagePropertyImprovement;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imagePropertyImprovement[j], updateCallBack);
        }
      }
    }

    let nonResidentialUses = state.upd.property.site.siteFeature.nonResidentialUses.slice();

    for(let i=0;i<nonResidentialUses.length;i++){
      let imageNonResidentialUse = nonResidentialUses[i].imageNonResidentialUse?nonResidentialUses[i].imageNonResidentialUse.slice():[];
      for(let j=0;j<imageNonResidentialUse.length;j++){
        imageNonResidentialUse[j].typeFk = nonResidentialUses[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageNonResidentialUse[j].ID || imageNonResidentialUse[j].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageNonResidentialUse[j].ID = ID;
            if(callCounter>=imageNonResidentialUse.length){
              let upd = Object.assign({}, state.upd);
              upd.property.site.siteFeature.nonResidentialUses[i].imageNonResidentialUse = imageNonResidentialUse;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageNonResidentialUse[j], updateCallBack);
        }
      }
    }

    //BUILDING

    callCounter = 0;
    let buildings = state.upd.property.buildings.slice();
    for(let i=0;i<buildings.length;i++){
      let imageDwellingFront = !buildings[i].imageDwellingFront?[]:buildings[i].imageDwellingFront.slice();
      for(let x=0;x<imageDwellingFront.length;x++){
        imageDwellingFront[x].typeFk = buildings[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageDwellingFront[x].ID || imageDwellingFront[x].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageDwellingFront[x].ID = ID;
            if(callCounter>=imageDwellingFront.length){
              let upd = Object.assign({}, state.upd);
              upd.property.buildings[i].imageDwellingFront = imageDwellingFront;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageDwellingFront[x], updateCallBack);
        }
      }

      let imageDwellingLeft = !buildings[i].imageDwellingLeft?[]:buildings[i].imageDwellingLeft.slice();
      for(let x=0;x<imageDwellingLeft.length;x++){
        imageDwellingLeft[x].typeFk = buildings[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageDwellingLeft[x].ID || imageDwellingLeft[x].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageDwellingLeft[x].ID = ID;
            if(callCounter>=imageDwellingLeft.length){
              let upd = Object.assign({}, state.upd);
              upd.property.buildings[i].imageDwellingLeft = imageDwellingLeft;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageDwellingLeft[x], updateCallBack);
        }
      }

      let imageDwellingRight = !buildings[i].imageDwellingRight?[]:buildings[i].imageDwellingRight.slice();
      for(let x=0;x<imageDwellingRight.length;x++){
        imageDwellingRight[x].typeFk = buildings[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageDwellingRight[x].ID || imageDwellingRight[x].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageDwellingRight[x].ID = ID;
            if(callCounter>=imageDwellingRight.length){
              let upd = Object.assign({}, state.upd);
              upd.property.buildings[i].imageDwellingRight = imageDwellingRight;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageDwellingRight[x], updateCallBack);
        }
      }

      let imageDwellingRear = !buildings[i].imageDwellingRear?[]:buildings[i].imageDwellingRear.slice();
      for(let x=0;x<imageDwellingRear.length;x++){
        imageDwellingRear[x].typeFk = buildings[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageDwellingRear[x].ID || imageDwellingRear[x].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageDwellingRear[x].ID = ID;
            if(callCounter>=imageDwellingRear.length){
              let upd = Object.assign({}, state.upd);
              upd.property.buildings[i].imageDwellingRear = imageDwellingRear;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageDwellingRear[x], updateCallBack);
        }
      }

      let imageStructureFront = !buildings[i].imageStructureFront?[]:buildings[i].imageStructureFront.slice();
      for(let x=0;x<imageStructureFront.length;x++){
        imageStructureFront[x].typeFk = buildings[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageStructureFront[x].ID || imageStructureFront[x].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageStructureFront[x].ID = ID;
            if(callCounter>=imageStructureFront.length){
              let upd = Object.assign({}, state.upd);
              upd.property.buildings[i].imageStructureFront = imageStructureFront;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageStructureFront[x], updateCallBack);
        }
      }

      let imageStructureRear = !buildings[i].imageStructureRear?[]:buildings[i].imageStructureRear.slice();
      for(let x=0;x<imageStructureRear.length;x++){
        imageStructureRear[x].typeFk = buildings[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageStructureRear[x].ID || imageStructureRear[x].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageStructureRear[x].ID = ID;
            if(callCounter>=imageStructureRear.length){
              let upd = Object.assign({}, state.upd);
              upd.property.buildings[i].imageStructureRear = imageStructureRear;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageStructureRear[x], updateCallBack);
        }
      }

      let imageStructureLeft = !buildings[i].imageStructureLeft?[]:buildings[i].imageStructureLeft.slice();
      for(let x=0;x<imageStructureLeft.length;x++){
        imageStructureLeft[x].typeFk = buildings[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageStructureLeft[x].ID || imageStructureLeft[x].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageStructureLeft[x].ID = ID;
            if(callCounter>=imageStructureLeft.length){
              let upd = Object.assign({}, state.upd);
              upd.property.buildings[i].imageStructureLeft = imageStructureLeft;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageStructureLeft[x], updateCallBack);
        }
      }

      let imageStructureRight = !buildings[i].imageStructureRight?[]:buildings[i].imageStructureRight.slice();
      for(let x=0;x<imageStructureRight.length;x++){
        imageStructureRight[x].typeFk = buildings[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageStructureRight[x].ID || imageStructureRight[x].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageStructureRight[x].ID = ID;
            if(callCounter>=imageStructureRight.length){
              let upd = Object.assign({}, state.upd);
              upd.property.buildings[i].imageStructureRight = imageStructureRight;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageStructureRight[x], updateCallBack);
        }
      }

      let imageBuildingFront = !buildings[i].imageBuildingFront?[]:buildings[i].imageBuildingFront.slice();
      for(let x=0;x<imageBuildingFront.length;x++){
        imageBuildingFront[x].typeFk = buildings[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageBuildingFront[x].ID || imageBuildingFront[x].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageBuildingFront[x].ID = ID;
            if(callCounter>=imageBuildingFront.length){
              let upd = Object.assign({}, state.upd);
              upd.property.buildings[i].imageBuildingFront = imageBuildingFront;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageBuildingFront[x], updateCallBack);
        }
      }

      let imageBuildingRear = !buildings[i].imageBuildingRear?[]:buildings[i].imageBuildingRear.slice();
      for(let x=0;x<imageBuildingRear.length;x++){
        imageBuildingRear[x].typeFk = buildings[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageBuildingRear[x].ID || imageBuildingRear[x].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageBuildingRear[x].ID = ID;
            if(callCounter>=imageBuildingRear.length){
              let upd = Object.assign({}, state.upd);
              upd.property.buildings[i].imageBuildingRear = imageBuildingRear;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageBuildingRear[x], updateCallBack);
        }
      }

      let imageBuildingLeft = !buildings[i].imageBuildingLeft?[]:buildings[i].imageBuildingLeft.slice();
      for(let x=0;x<imageBuildingLeft.length;x++){
        imageBuildingLeft[x].typeFk = buildings[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageBuildingLeft[x].ID || imageBuildingLeft[x].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageBuildingLeft[x].ID = ID;
            if(callCounter>=imageBuildingLeft.length){
              let upd = Object.assign({}, state.upd);
              upd.property.buildings[i].imageBuildingLeft = imageBuildingLeft;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageBuildingLeft[x], updateCallBack);
        }
      }

      let imageBuildingRight = !buildings[i].imageBuildingRight?[]:buildings[i].imageBuildingRight.slice();
      for(let x=0;x<imageBuildingRight.length;x++){
        imageBuildingRight[x].typeFk = buildings[i].ID;
        //any photo with ID means it's already uploaded
        if(!imageBuildingRight[x].ID || imageBuildingRight[x].ID===-1){
          // eslint-disable-next-line no-loop-func
          let updateCallBack = (ID)=>{
            callCounter++;
            imageBuildingRight[x].ID = ID;
            if(callCounter>=imageBuildingRight.length){
              let upd = Object.assign({}, state.upd);
              upd.property.buildings[i].imageBuildingRight = imageBuildingRight;
              setState({upd:upd});
            }
          }

          await uploadPhoto(imageBuildingRight[x], updateCallBack);
        }
      }

      let exteriorDeficiencies = !buildings[i].exteriorDeficiencies?[]:buildings[i].exteriorDeficiencies.slice();
      for(let x=0;x<exteriorDeficiencies.length;x++){
        let imageExteriorDeficiency = exteriorDeficiencies[x].imageExteriorDeficiency?exteriorDeficiencies[x].imageExteriorDeficiency.slice():[];
        for(let x1=0;x1<imageExteriorDeficiency.length;x1++){
   
          imageExteriorDeficiency[x1].typeFk = exteriorDeficiencies[x].ID;
          //any photo with ID means it's already uploaded
          if(!imageExteriorDeficiency[x1].ID || imageExteriorDeficiency[x1].ID===-1){
            // eslint-disable-next-line no-loop-func
            let updateCallBack = (ID)=>{
              callCounter++;
              imageExteriorDeficiency[x1].ID = ID;
              if(callCounter>=imageExteriorDeficiency.length){
                let upd = Object.assign({}, state.upd);
                upd.property.buildings[i].exteriorDeficiencies[x].imageExteriorDeficiency = imageExteriorDeficiency;
                setState({upd:upd});
              }
            }

            await uploadPhoto(imageExteriorDeficiency[x1], updateCallBack);
          }
        }
      }

      let exteriorUpdates = !buildings[i].exteriorUpdates?[]:buildings[i].exteriorUpdates.slice();
      for(let x=0;x<exteriorUpdates.length;x++){
        let imageExteriorUpdate = exteriorUpdates[x].imageExteriorUpdate?exteriorUpdates[x].imageExteriorUpdate.slice():[];
        for(let x1=0;x1<imageExteriorUpdate.length;x1++){
          imageExteriorUpdate[x1].typeFk = exteriorUpdates[x].ID;
          //any photo with ID means it's already uploaded
          if(!imageExteriorUpdate[x1].ID || imageExteriorUpdate[x1].ID===-1){
            // eslint-disable-next-line no-loop-func
            let updateCallBack = (ID)=>{
              callCounter++;
              imageExteriorUpdate[x1].ID = ID;
              if(callCounter>=imageExteriorUpdate.length){
                let upd = Object.assign({}, state.upd);
                upd.property.buildings[i].exteriorUpdates[x].imageExteriorUpdate = imageExteriorUpdate;
                setState({upd:upd});
              }
            }

            await uploadPhoto(imageExteriorUpdate[x1], updateCallBack);
          }
        }
      }

      let condoCarStorages = !buildings[i].condoCarStorages?[]:buildings[i].condoCarStorages.slice();
      for(let x=0;x<condoCarStorages.length;x++){
        let imageOutsideGarage = condoCarStorages[x].imageOutsideGarage?condoCarStorages[x].imageOutsideGarage.slice():[];
        let imageInsideGarage = condoCarStorages[x].imageInsideGarage?condoCarStorages[x].imageInsideGarage.slice():[];
        let imageCarport = condoCarStorages[x].imageCarport?condoCarStorages[x].imageCarport.slice():[];
        let imageOpenAssigned = condoCarStorages[x].imageOpenAssigned?condoCarStorages[x].imageOpenAssigned.slice():[];

        for(let x1=0;x1<imageOutsideGarage.length;x1++){
          imageOutsideGarage[x1].typeFk = condoCarStorages[x].ID;
          //any photo with ID means it's already uploaded
          if(!imageOutsideGarage[x1].ID || imageOutsideGarage[x1].ID===-1){
            // eslint-disable-next-line no-loop-func
            let updateCallBack = (ID)=>{
              callCounter++;
              imageOutsideGarage[x1].ID = ID;
              if(callCounter>=imageOutsideGarage.length){
                let upd = Object.assign({}, state.upd);
                upd.property.buildings[i].condoCarStorages[x].imageOutsideGarage = imageOutsideGarage;
                setState({upd:upd});
              }
            }

            await uploadPhoto(imageOutsideGarage[x1], updateCallBack);
          }
        }

        for(let x1=0;x1<imageInsideGarage.length;x1++){
          imageInsideGarage[x1].typeFk = condoCarStorages[x].ID;
          //any photo with ID means it's already uploaded
          if(!imageInsideGarage[x1].ID || imageInsideGarage[x1].ID===-1){
            // eslint-disable-next-line no-loop-func
            let updateCallBack = (ID)=>{
              callCounter++;
              imageInsideGarage[x1].ID = ID;
              if(callCounter>=imageInsideGarage.length){
                let upd = Object.assign({}, state.upd);
                upd.property.buildings[i].condoCarStorages[x].imageInsideGarage = imageInsideGarage;
                setState({upd:upd});
              }
            }

            await uploadPhoto(imageInsideGarage[x1], updateCallBack);
          }
        }

        for(let x1=0;x1<imageCarport.length;x1++){
          imageCarport[x1].typeFk = condoCarStorages[x].ID;
          //any photo with ID means it's already uploaded
          if(!imageCarport[x1].ID || imageCarport[x1].ID===-1){
            // eslint-disable-next-line no-loop-func
            let updateCallBack = (ID)=>{
              callCounter++;
              imageCarport[x1].ID = ID;
              if(callCounter>=imageCarport.length){
                let upd = Object.assign({}, state.upd);
                upd.property.buildings[i].condoCarStorages[x].imageCarport = imageCarport;
                setState({upd:upd});
              }
            }

            await uploadPhoto(imageCarport[x1], updateCallBack);
          }
        }

        for(let x1=0;x1<imageOpenAssigned.length;x1++){
          imageOpenAssigned[x1].typeFk = condoCarStorages[x].ID;
          //any photo with ID means it's already uploaded
          if(!imageOpenAssigned[x1].ID || imageOpenAssigned[x1].ID===-1){
            // eslint-disable-next-line no-loop-func
            let updateCallBack = (ID)=>{
              callCounter++;
              imageOpenAssigned[x1].ID = ID;
              if(callCounter>=imageOpenAssigned.length){
                let upd = Object.assign({}, state.upd);
                upd.property.buildings[i].condoCarStorages[x].imageOpenAssigned = imageOpenAssigned;
                setState({upd:upd});
              }
            }

            await uploadPhoto(imageOpenAssigned[x1], updateCallBack);
          }
        }
        let carStoragesDeficiencies = condoCarStorages[x].carStoragesDeficiencies?condoCarStorages[x].carStoragesDeficiencies.slice():[];

        for(let y=0;y<carStoragesDeficiencies.length;y++){
          let imageCondoCarStorageDeficiency = carStoragesDeficiencies[y].imageCondoCarStorageDeficiency?carStoragesDeficiencies[y].imageCondoCarStorageDeficiency.slice():[];

          for(let y1=0;y1<imageCondoCarStorageDeficiency.length;y1++){
            imageCondoCarStorageDeficiency[y1].typeFk = carStoragesDeficiencies[y].ID;
            //any photo with ID means it's already uploaded
            if(!imageCondoCarStorageDeficiency[y1].ID || imageCondoCarStorageDeficiency[y1].ID===-1){
              // eslint-disable-next-line no-loop-func
              let updateCallBack = (ID)=>{
                callCounter++;
                imageCondoCarStorageDeficiency[y1].ID = ID;
                if(callCounter>=imageCondoCarStorageDeficiency.length){
                  let upd = Object.assign({}, state.upd);
                  upd.property.buildings[i].condoCarStorages[x].carStoragesDeficiencies[y].imageCondoCarStorageDeficiency = imageCondoCarStorageDeficiency;
                  setState({upd:upd});
                }
              }

              await uploadPhoto(imageCondoCarStorageDeficiency[y1], updateCallBack);
            }
          }
        }
      }

      let units = buildings[i].units.slice();

      for(let j=0;j<units.length;j++){
        
        let unitFeatures = !units[j].unitFeatures?[]:units[j].unitFeatures.slice();
        

        for(let x=0;x<unitFeatures.length;x++){
          
          let imageFeatureType = unitFeatures[x].imageFeatureType?unitFeatures[x].imageFeatureType.slice():[];

          for(let x1=0;x1<imageFeatureType.length;x1++){
            imageFeatureType[x1].typeFk = unitFeatures[x].ID;
            //any photo with ID means it's already uploaded
            if(!imageFeatureType[x1].ID || imageFeatureType[x1].ID===-1){
              // eslint-disable-next-line no-loop-func
              let updateCallBack = (ID)=>{
                callCounter++;
                imageFeatureType[x1].ID = ID;
                if(callCounter>=imageFeatureType.length){
                  let upd = Object.assign({}, state.upd);
                  upd.property.buildings[i].units[j].imageFeatureType = imageFeatureType;
                  setState({upd:upd});
                }
              }

              await uploadPhoto(imageFeatureType[x1], updateCallBack);
            }
          }
        }

        let mechanicalDeficiencies = !units[j].mechanicalDeficiencies.slice?[]:units[j].mechanicalDeficiencies.slice();
        let mechanicalUpdates = !units[j].mechanicalUpdates?[]:units[j].mechanicalUpdates.slice();

        for(let x=0;x<mechanicalDeficiencies.length;x++){
          let imageMechanicalDeficiency = mechanicalDeficiencies[x].imageMechanicalDeficiency?mechanicalDeficiencies[x].imageMechanicalDeficiency.slice():[];

          for(let x1=0;x1<imageMechanicalDeficiency.length;x1++){
            imageMechanicalDeficiency[x1].typeFk = mechanicalDeficiencies[x].ID;
            //any photo with ID means it's already uploaded
            if(!imageMechanicalDeficiency[x1].ID || imageMechanicalDeficiency[x1].ID===-1){
              // eslint-disable-next-line no-loop-func
              let updateCallBack = (ID)=>{
                callCounter++;
                imageMechanicalDeficiency[x1].ID = ID;
                if(callCounter>=imageMechanicalDeficiency.length){
                  let upd = Object.assign({}, state.upd);
                  upd.property.buildings[i].units[j].mechanicalDeficiencies[x].imageMechanicalDeficiency = imageMechanicalDeficiency;
                  setState({upd:upd});
                }
              }

              await uploadPhoto(imageMechanicalDeficiency[x1], updateCallBack);
            }
          }
        }

        for(let x=0;x<mechanicalUpdates.length;x++){
          let imageMechanicalUpdate = mechanicalUpdates[x].imageMechanicalUpdate?mechanicalUpdates[x].imageMechanicalUpdate.slice():[];

          for(let x1=0;x1<imageMechanicalUpdate.length;x1++){
            imageMechanicalUpdate[x1].typeFk = mechanicalUpdates[x].ID;
            //any photo with ID means it's already uploaded
            if(!imageMechanicalUpdate[x1].ID || imageMechanicalUpdate[x1].ID===-1){
              // eslint-disable-next-line no-loop-func
              let updateCallBack = (ID)=>{
                callCounter++;
                imageMechanicalUpdate[x1].ID = ID;
                if(callCounter>=imageMechanicalUpdate.length){
                  let upd = Object.assign({}, state.upd);
                  upd.property.buildings[i].units[j].mechanicalUpdates[x].imageMechanicalUpdate = imageMechanicalUpdate;
                  setState({upd:upd});
                }
              }

              await uploadPhoto(imageMechanicalUpdate[x1], updateCallBack);
            }
          }
        }

        let condoUnitViews = !units[j].unitView.views?[]:units[j].unitView.views.slice();
        for(let x=0;x<condoUnitViews.length;x++){
          let imageView = condoUnitViews[x].imageView?condoUnitViews[x].imageView.slice():[];

          for(let x1=0;x1<imageView.length;x1++){
            imageView[x1].typeFk = condoUnitViews[x].ID;
            //any photo with ID means it's already uploaded
            if(!imageView[x1].ID || imageView[x1].ID===-1){
              // eslint-disable-next-line no-loop-func
              let updateCallBack = (ID)=>{
                callCounter++;
                imageView[x1].ID = ID;
                if(callCounter>=imageView.length){
                  let upd = Object.assign({}, state.upd);
                  upd.property.buildings[i].units[j].unitView.views[x].imageView = imageView;
                  setState({upd:upd});
                }
              }

              await uploadPhoto(imageView[x1], updateCallBack);
            }
          }
        }

        
        let levels = units[j].levels.slice();

        //GARAGE
        let garages = units[j].garages.slice();
        for(let x=0;x<garages.length;x++){
          let imageOutsideGarage = garages[x].imageOutsideGarage?garages[x].imageOutsideGarage.slice():[];
          let imageInsideGarage = garages[x].imageInsideGarage?garages[x].imageInsideGarage.slice():[];

          for(let x1=0;x1<imageOutsideGarage.length;x1++){
            imageOutsideGarage[x1].typeFk = garages[x].ID;
            //any photo with ID means it's already uploaded
            if(!imageOutsideGarage[x1].ID || imageOutsideGarage[x1].ID===-1){
              // eslint-disable-next-line no-loop-func
              let updateCallBack = (ID)=>{
                callCounter++;
                imageOutsideGarage[x1].ID = ID;
                if(callCounter>=imageOutsideGarage.length){
                  let upd = Object.assign({}, state.upd);
                  upd.property.buildings[i].units[j].garages[x].imageOutsideGarage = imageOutsideGarage;
                  setState({upd:upd});
                }
              }

              await uploadPhoto(imageOutsideGarage[x1], updateCallBack);
            }
          }

          for(let x1=0;x1<imageInsideGarage.length;x1++){
            imageInsideGarage[x1].typeFk = garages[x].ID;
            //any photo with ID means it's already uploaded
            if(!imageInsideGarage[x1].ID || imageInsideGarage[x1].ID===-1){
              // eslint-disable-next-line no-loop-func
              let updateCallBack = (ID)=>{
                callCounter++;
                imageInsideGarage[x1].ID = ID;
                if(callCounter>=imageInsideGarage.length){
                  let upd = Object.assign({}, state.upd);
                  upd.property.buildings[i].units[j].garages[x].imageInsideGarage = imageInsideGarage;
                  setState({upd:upd});
                }
              }

              await uploadPhoto(imageInsideGarage[x1], updateCallBack);
            }
          }

          let garageDeficiencies = garages[x].garageDeficiencies.slice();
          for(let y=0;y<garageDeficiencies.length;y++){
            let imageGarageDeficiency = garageDeficiencies[y].imageGarageDeficiency?garageDeficiencies[y].imageGarageDeficiency.slice():[];
            for(let y1=0;y1<imageGarageDeficiency.length;y1++){
              imageGarageDeficiency[y1].typeFk = garageDeficiencies[y].ID;
              //any photo with ID means it's already uploaded
              if(!imageGarageDeficiency[y1].ID || imageGarageDeficiency[y1].ID===-1){
                // eslint-disable-next-line no-loop-func
                let updateCallBack = (ID)=>{
                  callCounter++;
                  imageGarageDeficiency[y1].ID = ID;
                  if(callCounter>=imageGarageDeficiency.length){
                    let upd = Object.assign({}, state.upd);
                    upd.property.buildings[i].units[j].garages[x].garageDeficiencies[y].imageGarageDeficiency = imageGarageDeficiency;
                    setState({upd:upd});
                  }
                }

                await uploadPhoto(imageGarageDeficiency[y1], updateCallBack);
              }
            }
          }
        }

        for(let k=0;k<levels.length;k++){
          let imageFloorPlan = !levels[k].imageFloorPlan?[]:levels[k].imageFloorPlan.slice();
          for(let x=0;x<imageFloorPlan.length;x++){
            imageFloorPlan[x].typeFk = levels[k].ID;
            //any photo with ID means it's already uploaded
            if(!imageFloorPlan[x].ID || imageFloorPlan[x].ID===-1){
              // eslint-disable-next-line no-loop-func
              let updateCallBack = (ID)=>{
                callCounter++;
                imageFloorPlan[x].ID = ID;
                if(callCounter>=imageFloorPlan.length){
                  let upd = Object.assign({}, state.upd);
                  upd.property.buildings[i].units[j].levels[k].imageFloorPlan = imageFloorPlan;
                  setState({upd:upd});
                }
              }
    
              await uploadPhoto(imageFloorPlan[x], updateCallBack);
            }
          }

          let rooms = levels[k].rooms.slice();

          for(let m=0;m<rooms.length;m++){
            let imageRoom = rooms[m].imageRoom?rooms[m].imageRoom.slice():[];
            let imageLivingroom = rooms[m].imageLivingroom?rooms[m].imageLivingroom.slice():[];
            let imageKitchen = rooms[m].imageKitchen?rooms[m].imageKitchen.slice():[];
            let imageBathroom = rooms[m].imageBathroom?rooms[m].imageBathroom.slice():[];
            let imageOven = rooms[m].imageOven?rooms[m].imageOven.slice():[];
            let interiorDeficiencies = rooms[m].interiorDeficiencies?rooms[m].interiorDeficiencies.slice():[];
            let interiorUpdates = rooms[m].interiorUpdates?rooms[m].interiorUpdates.slice():[];

            for(let x1=0;x1<imageRoom.length;x1++){
              imageRoom[x1].typeFk = rooms[m].ID;
              //any photo with ID means it's already uploaded
              if(!imageRoom[x1].ID || imageRoom[x1].ID===-1){
                // eslint-disable-next-line no-loop-func
                let updateCallBack = (ID)=>{
                  callCounter++;
                  imageRoom[x1].ID = ID;
                  if(callCounter>=imageRoom.length){
                    let upd = Object.assign({}, state.upd);
                    upd.property.buildings[i].units[j].levels[k].rooms[m].imageRoom = imageRoom;
                    setState({upd:upd});
                  }
                }
  
                await uploadPhoto(imageRoom[x1], updateCallBack);
              }
            }
            for(let x1=0;x1<imageLivingroom.length;x1++){
              imageLivingroom[x1].typeFk = rooms[m].ID;
              //any photo with ID means it's already uploaded
              if(!imageLivingroom[x1].ID || imageLivingroom[x1].ID===-1){
                // eslint-disable-next-line no-loop-func
                let updateCallBack = (ID)=>{
                  callCounter++;
                  imageLivingroom[x1].ID = ID;
                  if(callCounter>=imageLivingroom.length){
                    let upd = Object.assign({}, state.upd);
                    upd.property.buildings[i].units[j].levels[k].rooms[m].imageLivingroom = imageLivingroom;
                    setState({upd:upd});
                  }
                }
  
                await uploadPhoto(imageLivingroom[x1], updateCallBack);
              }
            }

            for(let x1=0;x1<imageKitchen.length;x1++){
              imageKitchen[x1].typeFk = rooms[m].ID;
              //any photo with ID means it's already uploaded
              if(!imageKitchen[x1].ID || imageKitchen[x1].ID===-1){
                // eslint-disable-next-line no-loop-func
                let updateCallBack = (ID)=>{
                  callCounter++;
                  imageKitchen[x1].ID = ID;
                  if(callCounter>=imageKitchen.length){
                    let upd = Object.assign({}, state.upd);
                    upd.property.buildings[i].units[j].levels[k].rooms[m].imageKitchen = imageKitchen;
                    setState({upd:upd});
                  }
                }
  
                await uploadPhoto(imageKitchen[x1], updateCallBack);
              }
            }

            for(let x1=0;x1<imageBathroom.length;x1++){
              imageBathroom[x1].typeFk = rooms[m].ID;
              //any photo with ID means it's already uploaded
              if(!imageBathroom[x1].ID || imageBathroom[x1].ID===-1){
                // eslint-disable-next-line no-loop-func
                let updateCallBack = (ID)=>{
                  callCounter++;
                  imageBathroom[x1].ID = ID;
                  if(callCounter>=imageBathroom.length){
                    let upd = Object.assign({}, state.upd);
                    upd.property.buildings[i].units[j].levels[k].rooms[m].imageBathroom = imageBathroom;
                    setState({upd:upd});
                  }
                }
  
                await uploadPhoto(imageBathroom[x1], updateCallBack);
              }
            }

            for(let x1=0;x1<imageOven.length;x1++){
              imageOven[x1].typeFk = rooms[m].ID;
              //any photo with ID means it's already uploaded
              if(!imageOven[x1].ID || imageOven[x1].ID===-1){
                // eslint-disable-next-line no-loop-func
                let updateCallBack = (ID)=>{
                  callCounter++;
                  imageOven[x1].ID = ID;
                  if(callCounter>=imageOven.length){
                    let upd = Object.assign({}, state.upd);
                    upd.property.buildings[i].units[j].levels[k].rooms[m].imageOven = imageOven;
                    setState({upd:upd});
                  }
                }
  
                await uploadPhoto(imageOven[x1], updateCallBack);
              }
            }


            for(let n=0;n<interiorDeficiencies.length;n++){
              let imageDeficiency = interiorDeficiencies[n].imageDeficiency?interiorDeficiencies[n].imageDeficiency.slice():[];

              for(let x1=0;x1<imageDeficiency.length;x1++){
                
                imageDeficiency[x1].typeFk = interiorDeficiencies[n].ID;
                //any photo with ID means it's already uploaded
                if(!imageDeficiency[x1].ID || imageDeficiency[x1].ID===-1){
                  // eslint-disable-next-line no-loop-func
                  let updateCallBack = (ID)=>{
                    callCounter++;
                    imageDeficiency[x1].ID = ID;
                    if(callCounter>=imageDeficiency.length){
                      let upd = Object.assign({}, state.upd);
                      upd.property.buildings[i].units[j].levels[k].rooms[m].interiorDeficiencies[n].imageDeficiency = imageDeficiency;
                      setState({upd:upd});
                    }
                  }
    
                  await uploadPhoto(imageDeficiency[x1], updateCallBack);
                }
              }
            }

            for(let n=0;n<interiorUpdates.length;n++){
              let imageUpdate = interiorUpdates[n].imageUpdate?interiorUpdates[n].imageUpdate.slice():[];

              for(let x1=0;x1<imageUpdate.length;x1++){
                imageUpdate[x1].typeFk = interiorUpdates[n].ID;
                //any photo with ID means it's already uploaded
                if(!imageUpdate[x1].ID || imageUpdate[x1].ID===-1){
                  // eslint-disable-next-line no-loop-func
                  let updateCallBack = (ID)=>{
                    callCounter++;
                    imageUpdate[x1].ID = ID;
                    if(callCounter>=imageUpdate.length){
                      let upd = Object.assign({}, state.upd);
                      upd.property.buildings[i].units[j].levels[k].rooms[m].interiorUpdates[n].imageUpdate = imageUpdate;
                      setState({upd:upd});
                    }
                  }
    
                  await uploadPhoto(imageUpdate[x1], updateCallBack);
                }
              }
            }
          }
        }
      }
    }
    setState({action:''});
  }

  const initializePhotos = (loadedPhotos)=>{
    let nonRepeatType = [
      "STREET_ADDRESS",
      "UNIT_NUMBER",
      "STREET_LEFT",
      "STREET_RIGHT",
      "ROAD_UNDER_MAINTAINED",
      "OTHER",
      "SIGNATURE"
    ]
    //PROCESS THE LOADED PHOTO AND CATEGORIZE THEM
    let duplicateType = {
      "GARAGE_EXTERIOR":[
        "ATTACHED_GARAGE_EXTERIOR",
        "DETACHED_GARAGE_EXTERIOR",
        "BUILTIN_GARAGE_EXTERIOR",
      ],
      "GARAGE_INTERIOR":[
        "ATTACHED_GARAGE_INTERIOR",
        "DETACHED_GARAGE_INTERIOR",
        "BUILTIN_GARAGE_INTERIOR",
      ],
      "GARAGE_DEFICIENCY":[
        "SIDING_GARAGE_DEFICIENCY",
        "WINDOWS_GARAGE_DEFICIENCY",
        "DOORS_GARAGE_DEFICIENCY",
        "GARAGE_DOOR_GARAGE_DEFICIENCY",
        "EXTERIOR_WALLS_GARAGE_DEFICIENCY",
        "INTERIOR_WALLS_GARAGE_DEFICIENCY",
        "CEILING_GARAGE_DEFICIENCY",
        "ROOF_GARAGE_DEFICIENCY",
        "FOUNDATION_GARAGE_DEFICIENCY",
        "OTHER_GARAGE_DEFICIENCY",
      ],
      "CARSTORAGE_DEFICIENCY":[
        "SIDING_CARSTORAGE_DEFICIENCY",
        "WINDOWS_CARSTORAGE_DEFICIENCY",
        "DOORS_CARSTORAGE_DEFICIENCY",
        "GARAGE_DOOR_CARSTORAGE_DEFICIENCY",
        "EXTERIOR_WALLS_CARSTORAGE_DEFICIENCY",
        "INTERIOR_WALLS_CARSTORAGE_DEFICIENCY",
        "CEILING_CARSTORAGE_DEFICIENCY",
        "ROOF_CARSTORAGE_DEFICIENCY",
        "FOUNDATION_CARSTORAGE_DEFICIENCY",
        "OTHER_CARSTORAGE_DEFICIENCY",
      ],
      "CONDO_CAR_STORAGE_EXTERIOR":[
        "CONDO_ATTACHED_GARAGE_EXTERIOR",
        "CONDO_DETACHED_GARAGE_EXTERIOR",
        "CONDO_BUILTIN_GARAGE_EXTERIOR",
        "CONDO_CARPORT_EXTERIOR",
        "CONDO_OPEN_UNASSIGNED_EXTERIOR",
        "CONDO_OPEN_ASSIGNED_EXTERIOR",
      ],
      "CONDO_CAR_STORAGE_INTERIOR":[
        "CONDO_ATTACHED_GARAGE_INTERIOR",
        "CONDO_DETACHED_GARAGE_INTERIOR",
        "CONDO_BUILTIN_GARAGE_INTERIOR",
        "CONDO_CARPORT_INTERIOR",
        "CONDO_OPEN_UNASSIGNED_INTERIOR",
        "CONDO_OPEN_ASSIGNED_INTERIOR",
      ],
      "INTERIOR_DEFICIENCY":[
        "FLOORING_INTERIOR_DEFICIENCY",
        "PLUMBING_FIXTURES_INTERIOR_DEFICIENCY",
        "ELECTRICAL_FIXTURES_INTERIOR_DEFICIENCY",
        "CABINET_COUNTERTOPS_INTERIOR_DEFICIENCY",
        "APPLIANCES_INTERIOR_DEFICIENCY",
        "WALLS_INTERIOR_DEFICIENCY",
        "CEILING_INTERIOR_DEFICIENCY",
        "SHOWER_TUB_SURROUND_INTERIOR_DEFICIENCY",
        "OTHER_INTERIOR_DEFICIENCY",
      ],
      "INTERIOR_UPDATE":[
        "FLOORING_INTERIOR_UPDATE",
        "PLUMBING_FIXTURES_INTERIOR_UPDATE",
        "ELECTRICAL_FIXTURES_INTERIOR_UPDATE",
        "CABINET_COUNTERTOPS_INTERIOR_UPDATE",
        "APPLIANCES_INTERIOR_UPDATE",
        "WALLS_INTERIOR_UPDATE",
        "CEILING_INTERIOR_UPDATE",
        "OTHER_INTERIOR_UPDATE",
      ],
      "EXTERIOR_DEFICIENCY":[
        "FOUNDATION_EXTERIOR_DEFICIENCY",
        "ROOF_EXTERIOR_DEFICIENCY",
        "SIDING_EXTERIOR_DEFICIENCY",
        "FASCIA_EXTERIOR_DEFICIENCY",
        "WINDOWS_EXTERIOR_DEFICIENCY",
        "DOORS_EXTERIOR_DEFICIENCY",
        "GUTTERS_DOWNSPOUTS_EXTERIOR_DEFICIENCY",
        "EAVES_EXTERIOR_DEFICIENCY",
        "CHIMNEY_EXTERIOR_DEFICIENCY",
        "PORCH_EXTERIOR_DEFICIENCY",
        "DECK_EXTERIOR_DEFICIENCY",
        "BALCONY_EXTERIOR_DEFICIENCY",
        "ENTRY_STAIRS_EXTERIOR_DEFICIENCY",
        "CARPORT_EXTERIOR_DEFICIENCY",
        "DRIVEWAY_EXTERIOR_DEFICIENCY",
        "INCOMPLETE_LANDSCAPING_EXTERIOR_DEFICIENCY",
        "OTHER_EXTERIOR_DEFICIENCY",
        "EXTERIOR_WALLS_EXTERIOR_DEFICIENCY",
      ],
      "EXTERIOR_UPDATE":[
        "SIDING_EXTERIOR_UPDATE",
        "DOORS_EXTERIOR_UPDATE",
        "WALLS_EXTERIOR_UPDATE",
        "ROOF_EXTERIOR_UPDATE",
        "FOUNDATION_EXTERIOR_UPDATE",
        "FENCE_EXTERIOR_UPDATE",
        "OTHER_EXTERIOR_UPDATE",
        "WINDOWS_EXTERIOR_UPDATE",
      ],
      "MECHANICAL_DEFICIENCY":[
        "PLUMBING_MECHANICAL_DEFICIENCY",
        "ELECTRICAL_MECHANICAL_DEFICIENCY",
        "HEATING_MECHANICAL_DEFICIENCY",
        "WATER_HEATER_MECHANICAL_DEFICIENCY",
        "COOLING_MECHANICAL_DEFICIENCY",
        "SUMP_PUMP_MECHANICAL_DEFICIENCY",
        "OTHER_MECHANICAL_DEFICIENCY",
      ],
      "MECHANICAL_UPDATE":[
        "PLUMBING_MECHANICAL_UPDATE",
        "ELECTRICAL_MECHANICAL_UPDATE",
        "HEATING_MECHANICAL_UPDATE",
        "WATER_HEATER_MECHANICAL_UPDATE",
        "COOLING_MECHANICAL_UPDATE",
        "SUMP_PUMP_MECHANICAL_UPDATE",
        "OTHER_MECHANICAL_UPDATE",
      ]
    }

    let newUPD = Object.assign({}, state.upd);
    let mappedCategory = {};
    for(let i=0;i<loadedPhotos.length;i++){
      let tmp = {
        ID:loadedPhotos[i].ID,
        name:loadedPhotos[i].name,
        type:loadedPhotos[i].type,
        typeFk:loadedPhotos[i].type_fk,
        size:loadedPhotos[i].file_size,
        description:loadedPhotos[i].description,
        status:'Loading',
        presign_url:loadedPhotos[i].presign_url
      }

      let found = false;
      if(nonRepeatType.indexOf(loadedPhotos[i].type)===-1){
        Object.keys(duplicateType).forEach(key => {
          let duplicateTypeValues = duplicateType[key];
          for(let j=0;j<duplicateTypeValues.length;j++){
            if(loadedPhotos[i].type===duplicateTypeValues[j]){
              if(!mappedCategory[key])
                mappedCategory[key] = [];
              if(!mappedCategory[key][loadedPhotos[i].type_fk])
                mappedCategory[key][loadedPhotos[i].type_fk] = [];
              mappedCategory[key][loadedPhotos[i].type_fk].push(tmp);
              found = true;
              break;
            }
          }
        });

        if(!found){
          if(!mappedCategory[loadedPhotos[i].type])
            mappedCategory[loadedPhotos[i].type] = [];
          if(!mappedCategory[loadedPhotos[i].type][loadedPhotos[i].type_fk])
            mappedCategory[loadedPhotos[i].type][loadedPhotos[i].type_fk] = [];
          mappedCategory[loadedPhotos[i].type][loadedPhotos[i].type_fk].push(tmp);
        }
      }
      else{
        if(!mappedCategory[loadedPhotos[i].type])
          mappedCategory[loadedPhotos[i].type] = [];
        mappedCategory[loadedPhotos[i].type].push(tmp);
      }
    }

    let photos;

    //OTHER PHOTO
    photos = mappedCategory["OTHER"]?mappedCategory["OTHER"]:[];
    newUPD.photos = photos;

    //STREET NUMBER
    photos = mappedCategory["STREET_ADDRESS"]?mappedCategory["STREET_ADDRESS"]:[];
    newUPD.imageStreetNumber = photos;

    //UNIT NUMBER
    photos = mappedCategory["UNIT_NUMBER"]?mappedCategory["UNIT_NUMBER"]:[];
    newUPD.imageUnitNumber = photos;

    //STREET LEFT
    photos = mappedCategory["STREET_LEFT"]?mappedCategory["STREET_LEFT"]:[];
    newUPD.imageStreetLeft = photos;

    //STREET RIGHT
    photos = mappedCategory["STREET_RIGHT"]?mappedCategory["STREET_RIGHT"]:[];
    newUPD.imageStreetRight = photos;
   
    //ROAD
    photos = mappedCategory["ROAD_UNDER_MAINTAINED"]?mappedCategory["ROAD_UNDER_MAINTAINED"]:[];
    newUPD.imageRoad = photos;

    //CONDITION
    let adverseSiteConditions = newUPD.property.site.siteFeature.adverseSiteConditions;
    for(let i=0;i<adverseSiteConditions.length;i++){
      if(adverseSiteConditions[i].ID && adverseSiteConditions[i].ID!==-1){
        if(mappedCategory["ADVERSE_SITE_CONDITIONS"] && mappedCategory["ADVERSE_SITE_CONDITIONS"][adverseSiteConditions[i].ID])
          adverseSiteConditions[i].imageCondition = mappedCategory["ADVERSE_SITE_CONDITIONS"][adverseSiteConditions[i].ID];
        else
          adverseSiteConditions[i].imageCondition = [];
      }
    }

    let views = newUPD.property.site.siteFeature.siteView.views?newUPD.property.site.siteFeature.siteView.views:[];

    for(let i=0;i<views.length;i++){
      if(views[i].ID && views[i].ID!==-1){
        if(mappedCategory["SF_VIEW"] && mappedCategory["SF_VIEW"][views[i].ID])
          views[i].imageView = mappedCategory["SF_VIEW"][views[i].ID];
        else
          views[i].imageView = [];
      }
    }

    //LOCATIONS
    let locations = newUPD.property.site.siteFeature.location.locations;
    for(let i=0;i<locations.length;i++){
      if(locations[i].ID && locations[i].ID!==-1){
        if(mappedCategory["WATERFRONT"] && mappedCategory["WATERFRONT"][locations[i].ID])
          locations[i].imageWaterFront = mappedCategory["WATERFRONT"][locations[i].ID];
          else
            locations[i].imageWaterFront = [];
      }
      if(locations[i].ID && locations[i].ID!==-1){
        if(mappedCategory["BORDERING_INFLUENCE"] && mappedCategory["BORDERING_INFLUENCE"][locations[i].ID])
          locations[i].imageBorder = mappedCategory["BORDERING_INFLUENCE"][locations[i].ID];
        else
          locations[i].imageBorder = [];
      }
    }
    
    let waterfrontSiteImprovements = newUPD.property.site.siteFeature.waterfrontSiteImprovements;
    for(let i=0;i<waterfrontSiteImprovements.length;i++){
      if(waterfrontSiteImprovements[i].ID && waterfrontSiteImprovements[i].ID!==-1){
        if(mappedCategory["WATERFRONT_SITE_IMPROVEMENTS"] && mappedCategory["WATERFRONT_SITE_IMPROVEMENTS"][waterfrontSiteImprovements[i].ID])
        waterfrontSiteImprovements[i].imageWaterfrontImprovement = mappedCategory["WATERFRONT_SITE_IMPROVEMENTS"][waterfrontSiteImprovements[i].ID];
        else
        waterfrontSiteImprovements[i].imageWaterfrontImprovement = [];
      }
    }

    let propertyImprovements = newUPD.property.site.siteFeature.propertyImprovements;
    for(let i=0;i<propertyImprovements.length;i++){
      if(propertyImprovements[i].ID && propertyImprovements[i].ID!==-1){
        let ingroundPoolConcerns = propertyImprovements[i].ingroundPoolConcerns?propertyImprovements[i].ingroundPoolConcerns.slice():[];
        for(let j=0;j<ingroundPoolConcerns.length;j++){
          if(mappedCategory["INGROUND_POOL_CONCERNS"] && mappedCategory["INGROUND_POOL_CONCERNS"][ingroundPoolConcerns[j].ID])
            propertyImprovements[i].ingroundPoolConcerns[j].imagePoolConcern = mappedCategory["INGROUND_POOL_CONCERNS"][ingroundPoolConcerns[j].ID];
          else
            propertyImprovements[i].ingroundPoolConcerns[j].imagePoolConcern = [];
        }
        
      }

      if(propertyImprovements[i].ID && propertyImprovements[i].ID!==-1){
        if(mappedCategory["PROPERTY_IMPROVEMENTS"] && mappedCategory["PROPERTY_IMPROVEMENTS"][propertyImprovements[i].ID])
          propertyImprovements[i].imagePropertyImprovement = mappedCategory["PROPERTY_IMPROVEMENTS"][propertyImprovements[i].ID];
        else
          propertyImprovements[i].imagePropertyImprovement = [];
      }
    }

    let nonResidentialUses = newUPD.property.site.siteFeature.nonResidentialUses;
    for(let i=0;i<nonResidentialUses.length;i++){
      if(nonResidentialUses[i].ID && nonResidentialUses[i].ID!==-1){
        if(mappedCategory["NONRESIDENTIAL_USE"] && mappedCategory["NONRESIDENTIAL_USE"][nonResidentialUses[i].ID])
          nonResidentialUses[i].imageNonResidentialUse = mappedCategory["NONRESIDENTIAL_USE"][nonResidentialUses[i].ID];
        else
          nonResidentialUses[i].imageNonResidentialUse = [];
      }
    }
    //BUILDING
    let buildings = newUPD.property.buildings;
    for(let i=0;i<buildings.length;i++){
      if(buildings[i].ID && buildings[i].ID!==-1){
        if(mappedCategory["STRUCTURE_RIGHT_SIDE"] && mappedCategory["STRUCTURE_RIGHT_SIDE"][buildings[i].ID])
          buildings[i].imageStructureRight = mappedCategory["STRUCTURE_RIGHT_SIDE"][buildings[i].ID];
        else
          buildings[i].imageStructureRight = [];
        if(mappedCategory["STRUCTURE_LEFT_SIDE"] && mappedCategory["STRUCTURE_LEFT_SIDE"][buildings[i].ID])
          buildings[i].imageStructureLeft = mappedCategory["STRUCTURE_LEFT_SIDE"][buildings[i].ID];
        else
          buildings[i].imageStructureLeft = [];
        if(mappedCategory["STRUCTURE_REAR"] && mappedCategory["STRUCTURE_REAR"][buildings[i].ID])
          buildings[i].imageStructureRear = mappedCategory["STRUCTURE_REAR"][buildings[i].ID];
        else
          buildings[i].imageStructureRear = [];
        if(mappedCategory["STRUCTURE_FRONT"] && mappedCategory["STRUCTURE_FRONT"][buildings[i].ID])
          buildings[i].imageStructureFront = mappedCategory["STRUCTURE_FRONT"][buildings[i].ID];
        else
          buildings[i].imageStructureFront = [];
        if(mappedCategory["VIEW_REAR"] && mappedCategory["VIEW_REAR"][buildings[i].ID])
          buildings[i].imageDwellingRear = mappedCategory["VIEW_REAR"][buildings[i].ID];
        else
          buildings[i].imageDwellingRear = [];
        if(mappedCategory["VIEW_RIGHT_SIDE"] && mappedCategory["VIEW_RIGHT_SIDE"][buildings[i].ID])
          buildings[i].imageDwellingRight = mappedCategory["VIEW_RIGHT_SIDE"][buildings[i].ID];
        else
          buildings[i].imageDwellingRight = [];
        if(mappedCategory["VIEW_LEFT_SIDE"] && mappedCategory["VIEW_LEFT_SIDE"][buildings[i].ID])
          buildings[i].imageDwellingLeft = mappedCategory["VIEW_LEFT_SIDE"][buildings[i].ID];
        else
          buildings[i].imageDwellingLeft = [];
        if(mappedCategory["VIEW_FRONT"] && mappedCategory["VIEW_FRONT"][buildings[i].ID])
          buildings[i].imageDwellingFront = mappedCategory["VIEW_FRONT"][buildings[i].ID];
        else
          buildings[i].imageDwellingFront = [];
        if(mappedCategory["BUILDING_FRONT"] && mappedCategory["BUILDING_FRONT"][buildings[i].ID])
          buildings[i].imageBuildingFront = mappedCategory["BUILDING_FRONT"][buildings[i].ID];
        else
          buildings[i].imageBuildingFront = [];
        if(mappedCategory["BUILDING_REAR"] && mappedCategory["BUILDING_REAR"][buildings[i].ID])
          buildings[i].imageBuildingRear = mappedCategory["BUILDING_REAR"][buildings[i].ID];
        else
          buildings[i].imageBuildingRear = [];
        if(mappedCategory["BUILDING_RIGHT"] && mappedCategory["BUILDING_RIGHT"][buildings[i].ID])
          buildings[i].imageBuildingRight = mappedCategory["BUILDING_RIGHT"][buildings[i].ID];
        else
          buildings[i].imageBuildingRight = [];
        if(mappedCategory["BUILDING_LEFT"] && mappedCategory["BUILDING_LEFT"][buildings[i].ID])
          buildings[i].imageBuildingLeft = mappedCategory["BUILDING_LEFT"][buildings[i].ID];
        else
          buildings[i].imageBuildingLeft = [];

        let exteriorDeficiencies = buildings[i].exteriorDeficiencies?buildings[i].exteriorDeficiencies.slice():[];
        let exteriorUpdates = buildings[i].exteriorUpdates?buildings[i].exteriorUpdates.slice():[];

        for(let j=0;j<exteriorDeficiencies.length;j++){
          if(mappedCategory["EXTERIOR_DEFICIENCY"] && mappedCategory["EXTERIOR_DEFICIENCY"][exteriorDeficiencies[j].ID])
            buildings[i].exteriorDeficiencies[j].imageExteriorDeficiency = mappedCategory["EXTERIOR_DEFICIENCY"][exteriorDeficiencies[j].ID];
          else
            buildings[i].exteriorDeficiencies[j].imageExteriorDeficiency = [];
        }
        for(let j=0;j<exteriorUpdates.length;j++){
          if(mappedCategory["EXTERIOR_UPDATE"] && mappedCategory["EXTERIOR_UPDATE"][exteriorUpdates[j].ID])
            buildings[i].exteriorUpdates[j].imageExteriorUpdate = mappedCategory["EXTERIOR_UPDATE"][exteriorUpdates[j].ID];
          else
            buildings[i].exteriorUpdates[j].imageExteriorUpdate = [];
        }

        let condoCarStorages = !buildings[i].condoCarStorages?[]:buildings[i].condoCarStorages;
        for(let x=0;x<condoCarStorages.length;x++){
          if(condoCarStorages[x].ID && condoCarStorages[x].ID!==1){
            if(mappedCategory["CONDO_CAR_STORAGE_EXTERIOR"] && mappedCategory["CONDO_CAR_STORAGE_EXTERIOR"][condoCarStorages[x].ID])
              condoCarStorages[x].imageOutsideGarage = mappedCategory["CONDO_CAR_STORAGE_EXTERIOR"][condoCarStorages[x].ID];
            else
              condoCarStorages[x].imageOutsideGarage = [];
            if(mappedCategory["CONDO_CAR_STORAGE_INTERIOR"] && mappedCategory["CONDO_CAR_STORAGE_INTERIOR"][condoCarStorages[x].ID])
              condoCarStorages[x].imageInsideGarage = mappedCategory["CONDO_CAR_STORAGE_INTERIOR"][condoCarStorages[x].ID];
            else
              condoCarStorages[x].imageInsideGarage = [];
            if(mappedCategory["CARPORT"] && mappedCategory["CARPORT"][condoCarStorages[x].ID])
              condoCarStorages[x].imageCarport = mappedCategory["CARPORT"][condoCarStorages[x].ID];
            else
              condoCarStorages[x].imageCarport = [];
            if(mappedCategory["OPEN_ASSIGNED"] && mappedCategory["OPEN_ASSIGNED"][condoCarStorages[x].ID])
              condoCarStorages[x].imageOpenAssigned = mappedCategory["OPEN_ASSIGNED"][condoCarStorages[x].ID];
            else
              condoCarStorages[x].imageOpenAssigned = [];
          }

          let carStoragesDeficiencies = condoCarStorages[x].carStoragesDeficiencies;

          for(let y=0;y<carStoragesDeficiencies.length;y++){
            if(carStoragesDeficiencies[y].ID && carStoragesDeficiencies[y].ID!==1){
              if(mappedCategory["CARSTORAGE_DEFICIENCY"] && mappedCategory["CARSTORAGE_DEFICIENCY"][carStoragesDeficiencies[y].ID])
                carStoragesDeficiencies[y].imageCondoCarStorageDeficiency = mappedCategory["CARSTORAGE_DEFICIENCY"][carStoragesDeficiencies[y].ID];
              else
                carStoragesDeficiencies[y].imageCondoCarStorageDeficiency = [];
            }
          }
        }
      }

      let units = buildings[i].units.slice();

      for(let j=0;j<units.length;j++){
        if(units[j].ID && units[j].ID!==-1){
          

          let unitFeatures = units[j].unitFeatures?units[j].unitFeatures.slice():[];
          for(let x=0;x<unitFeatures.length;x++){
            if(mappedCategory["FEATURE_TYPE"] && mappedCategory["FEATURE_TYPE"][unitFeatures[x].ID])
              unitFeatures[x].imageFeatureType = mappedCategory["FEATURE_TYPE"][unitFeatures[x].ID];
            else
              unitFeatures[x].imageFeatureType = [];
          }

          units[j].unitFeatures = unitFeatures;
          

          let mechanicalDeficiencies = units[j].mechanicalDeficiencies?units[j].mechanicalDeficiencies:[];
          let mechanicalUpdates = units[j].mechanicalDeficiencies?units[j].mechanicalUpdates:[];

          for(let k=0;k<mechanicalDeficiencies.length;k++){
            if(mappedCategory["MECHANICAL_DEFICIENCY"] && mappedCategory["MECHANICAL_DEFICIENCY"][mechanicalDeficiencies[k].ID])
              mechanicalDeficiencies[k].imageMechanicalDeficiency = mappedCategory["MECHANICAL_DEFICIENCY"][mechanicalDeficiencies[k].ID];
            else
              mechanicalDeficiencies[k].imageMechanicalDeficiency = [];
          }
          for(let k=0;k<mechanicalUpdates.length;k++){
            if(mappedCategory["MECHANICAL_UPDATE"] && mappedCategory["MECHANICAL_UPDATE"][mechanicalUpdates[k].ID])
              mechanicalUpdates[k].imageMechanicalUpdate = mappedCategory["MECHANICAL_UPDATE"][mechanicalUpdates[k].ID];
            else
              mechanicalUpdates[k].imageMechanicalUpdate = [];
          }
        }

        let condoUnitViews = !units[j].unitView.views?[]:units[j].unitView.views;
        for(let x=0;x<condoUnitViews.length;x++){
          if(condoUnitViews[x].ID && condoUnitViews[x].ID!==-1){
            if(mappedCategory["CONDO_VIEW"] && mappedCategory["CONDO_VIEW"][condoUnitViews[x].ID])
              condoUnitViews[x].imageView = mappedCategory["CONDO_VIEW"][condoUnitViews[x].ID];
            else
              condoUnitViews[x].imageView = [];
          }
        }
        let levels = units[j].levels;

        //GARAGE
        let garages = units[j].garages;
        for(let x=0;x<garages.length;x++){
          if(garages[x].ID && garages[x].ID!==-1){
            if(mappedCategory["GARAGE_EXTERIOR"] && mappedCategory["GARAGE_EXTERIOR"][garages[x].ID])
              garages[x].imageOutsideGarage = mappedCategory["GARAGE_EXTERIOR"][garages[x].ID];
            else
              garages[x].imageOutsideGarage = [];
            if(mappedCategory["GARAGE_INTERIOR"] && mappedCategory["GARAGE_INTERIOR"][garages[x].ID])
              garages[x].imageInsideGarage = mappedCategory["GARAGE_INTERIOR"][garages[x].ID];
            else
              garages[x].imageInsideGarage = [];
          }

          let garageDeficiencies = garages[x].garageDeficiencies.slice();
          for(let y=0;y<garageDeficiencies.length;y++){
            if(garageDeficiencies[y].ID && garageDeficiencies[y].ID!==-1){
              if(mappedCategory["GARAGE_DEFICIENCY"] && mappedCategory["GARAGE_DEFICIENCY"][garageDeficiencies[y].ID])
                garageDeficiencies[y].imageGarageDeficiency = mappedCategory["GARAGE_DEFICIENCY"][garageDeficiencies[y].ID];
              else
                garageDeficiencies[y].imageGarageDeficiency = [];
            }
          }
        }

        for(let k=0;k<levels.length;k++){
          if(mappedCategory["FLOOR_PLAN"] && mappedCategory["FLOOR_PLAN"][levels[k].ID])
            levels[k].imageFloorPlan = mappedCategory["FLOOR_PLAN"][levels[k].ID];
          else
          levels[k].imageFloorPlan = [];

          let rooms = levels[k].rooms;

          for(let m=0;m<rooms.length;m++){
            if(rooms[m].ID && rooms[m].ID!==-1){
              if(mappedCategory["ROOM"] && mappedCategory["ROOM"][rooms[m].ID])
                rooms[m].imageRoom = mappedCategory["ROOM"][rooms[m].ID];
              else
                rooms[m].imageRoom = [];
              if(mappedCategory["LIVING_ROOM"] && mappedCategory["LIVING_ROOM"][rooms[m].ID])
                rooms[m].imageLivingroom = mappedCategory["LIVING_ROOM"][rooms[m].ID];
              else
                rooms[m].imageLivingroom = [];
              if(mappedCategory["KITCHEN"] && mappedCategory["KITCHEN"][rooms[m].ID])
                rooms[m].imageKitchen = mappedCategory["KITCHEN"][rooms[m].ID];
              else
                rooms[m].imageKitchen = [];
              if(mappedCategory["BATHROOM"] && mappedCategory["BATHROOM"][rooms[m].ID])
                rooms[m].imageBathroom = mappedCategory["BATHROOM"][rooms[m].ID];
              else
                rooms[m].imageBathroom = [];
              if(mappedCategory["OVEN_RANGE"] && mappedCategory["OVEN_RANGE"][rooms[m].ID])
                rooms[m].imageOven = mappedCategory["OVEN_RANGE"][rooms[m].ID];
              else
                rooms[m].imageOven = [];
            }

            let interiorDeficiencies = rooms[m].interiorDeficiencies?rooms[m].interiorDeficiencies:[];
            let interiorUpdates = rooms[m].interiorUpdates?rooms[m].interiorUpdates:[];

            for(let n=0;n<interiorDeficiencies.length;n++){
              if(interiorDeficiencies[n].ID && interiorDeficiencies[n].ID!==-1){
                if(mappedCategory["INTERIOR_DEFICIENCY"] && mappedCategory["INTERIOR_DEFICIENCY"][interiorDeficiencies[n].ID])
                  interiorDeficiencies[n].imageDeficiency = mappedCategory["INTERIOR_DEFICIENCY"][interiorDeficiencies[n].ID];
                else
                  interiorDeficiencies[n].imageDeficiency = [];
              }
            }

            for(let n=0;n<interiorUpdates.length;n++){
              if(interiorUpdates[n].ID && interiorUpdates[n].ID!==-1){
                if(mappedCategory["INTERIOR_UPDATE"] && mappedCategory["INTERIOR_UPDATE"][interiorUpdates[n].ID])
                  interiorUpdates[n].imageUpdate = mappedCategory["INTERIOR_UPDATE"][interiorUpdates[n].ID];
                else
                  interiorUpdates[n].imageUpdate= [];
              }
            }
          }
        }
      }
    }

    setState({upd:newUPD});
  }

  const getPhotos = () => {
    let callBack = (response)=>{
      let code = response.data.code;
      if(code==='00'){
        let photos = response.data.data;
        initializePhotos(photos);
      }
    };
    httpGet('uniformPropertyDataset/photos/'+state.updFk, '', 'Oops, something went wrong and could not load the photos. Please try again later.', callBack);
  }

  const submitUPDRequest = (ID) => {
    let parameters = [
      {
        field:'updFk',
        value:state.updFk
      }
    ];
    
    let callBack = apiCallBack([{state:'showSubmittedPrompt', value:true}],[()=>{showMessage('success','Request submitted successfully, you will receive an email when the PDF report is ready.')}]);
    httpPost('uniformPropertyDataset/create/request', parameters, '', 'Oops, something went wrong and request could not be process successfully. Please try again later.', callBack);
  }

  //render
  let currentStep;
  let nextButton;
  let previousButton;

  if(state.currentStep===4)
    nextButton = <Button color="warning" disabled={state.reviewMessages.length>0}>Submit UPD</Button>
  else
    nextButton = <Button color="warning" onClick={handleNext}>Next</Button>
  
  if(state.currentStep!==0)
    previousButton = <Button color="info" onClick={(e)=>{e.preventDefault();updateStep(state.currentStep-1)}}>Go Back</Button>
  switch(parseInt(state.currentStep,10)){
    case 0: 
      currentStep = <form onSubmit={(e)=>{e.preventDefault();updateStep(state.currentStep+1)}}>
        <StepReportPropertyInfo {...props} upd={state.upd} update={update}/>
        <br/>
        <div className="align-right">
          {nextButton}
        </div>
        </form>;
      break;
    case 1: 
      currentStep = <form onSubmit={(e)=>{e.preventDefault();updateStep(state.currentStep+1)}}>
        <StepSite {...props} upd={state.upd} update={update} save={save}/>
        <br/>
        <div className="align-right">
          {previousButton} {nextButton}
        </div>
        </form>;
      break;
    case 2: 
      currentStep = <form onSubmit={(e)=>{e.preventDefault();updateStep(state.currentStep+1)}}>
        <StepUtilyAncillary {...props} upd={state.upd} update={update}/>
        <br/>
        <div className="align-right">
          {previousButton} {nextButton}
        </div>
      </form>;
      break;
    case 3: 
      currentStep = <form onSubmit={(e)=>{e.preventDefault();updateStep(state.currentStep+1)}}>
          <StepCertification {...props} upd={state.upd} update={update}/>
          <br/>
          <div className="align-right">
            {previousButton} {nextButton}
          </div>
        </form>;
      break;
    case 4: 
      currentStep = <form onSubmit={(e)=>{e.preventDefault();submitUPDRequest()}}>
        {
          state.reviewMessages.map(
            (message, index)=>{
              return <Alert color="danger" className="display-inline no-padding" style={{marginRight:'5px', marginBottom:'5px', padding:'5px !important'}}>
                <i className="fa fa-exclamation"/> {message}
              </Alert>
            }
          )
        }
        <StepReview {...props} upd={state.upd} update={update}/>
        <br/>
          <div className="align-right">
            {previousButton} {nextButton}
          </div>
        </form>;
      break;
    default:
      break;
  }
  return (
    <div>
      <Modal className="my-modal" isOpen={state.showSubmittedPrompt} toggle={toggleShowPrompt} >
        <ModalHeader hidden={true} toggle={toggleShowPrompt}></ModalHeader>
        <ModalBody>

          <center>
            <h5><i className="fa fa-check"></i> UPD Submitted Successfully</h5>
            <br/>
            Your UPD Report had been submitted for process successfully. It will be automatically delivered to System, if you need a copy for your record it will be available in your profile pipeline.<br/><br/>
            You may click <NavLink to="/uniform-property-dataset">here</NavLink> to return to the UPD Pipeline.
            Once the report is ready you will receive an email to access the report.<br/><br/>
          </center>
        </ModalBody>
      </Modal>
    <div>
      <Row className="justify-content-front gx-4">
        <Col sm="auto">

        </Col>
        <Col sm="auto">
          <NavLink to={`/appraisal/${state.upd.appraisalFk}`}>Back To Appraisal Order</NavLink>
        </Col>
      </Row>
    </div>
      <Nav tabs>
        <NavItem>
          <NavLink className="nav-link active" to="#">UPD (Uniform Property Dataset Report)</NavLink>
        </NavItem>
        <NavItem>
          <NavLink className="nav-link" to={"/uniform-property-dataset/post-completion-report/"+state.updFk}>PCR (Post Completion Report)</NavLink>
        </NavItem>
        <NavItem>
          <NavLink className="nav-link" to={"/uniform-property-dataset/file/"+state.updFk}>Generated Report</NavLink>
        </NavItem>
        <NavItem>
          <a className="nav-link" href="https://www.smartdraw.com/" target="_blank" rel="noopener noreferrer">Floor Plan - Smart Draw</a>
        </NavItem>
        <NavItem>
          <a className="nav-link" href="https://www.cubi.casa/" target="_blank" rel="noopener noreferrer">Floor Plan - Cubi Casa</a>
        </NavItem>
      </Nav>
      
      <div>
        <Row>
          <Col sm="12" className="align-right">
            <NavLink to="#" style={{fontSize:'20px'}} onClick={save}><i className="fa fa-floppy-o"/> Save</NavLink>
          </Col>
      </Row>
    </div>

      <MyFormStep steps = {state.steps} currentStep = {state.currentStep} updateStep = {updateStep} maxStep={state.maxStep}/>
      {currentStep}
    </div>
  )
}


export default UDPPropertyDataReport;